import React, { useState, useEffect, useRef } from 'react';
import './App.css';  // Nezapomeň přidat styly pro komponenty
import { Button, TextField, Typography, Paper, Container, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slider, Tooltip} from '@mui/material'; // Importujeme potřebné komponenty z MUI
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PauseIcon from '@mui/icons-material/Pause';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import bitwiseGlitch from "./assets/Bitwise_glitch.png";
import logo from "./assets/logo.png"; // ?? Importujeme obrázek
import Navbar from "./components/Navbar";
import Rules from "./pages/Rules"; // Import nové stránky
import Leaderboard from "./pages/Leaderboard"; // ? Importujeme Leaderboard
import SwitchAnimace from "./components/SwitchAnimace"; // Import nové tab komponenty
import axios from "axios"; /// pridavam kvuli recenzim
import ReviewForm from "./components/reviewForm";
import InlineReviewForm from "./components/InlineReviewForm";
import WestIcon from "@mui/icons-material/West";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import GameLauncher from "./game-platform/GameLauncher";
import { readGamePresentation } from "./game-platform/gamePresentation";
import EscapeBoxGameScreen from "./games/escape-box/EscapeBoxGameScreen";





console.log("Navbar:", Navbar);


//import { Link } from 'react-router-dom';

const backendUrl = 'https://limitless-mesa-46798-263e04e95cf1.herokuapp.com';
//const backendUrl = 'http://localhost:3000';
const API_BASE = "https://www.breakthemysterygame.cz";

// Jednoduchá sanitizace HTML pro bezpečné vykreslení textů
const sanitizeHtml = (html) => {
  if (!html) return "";
  return html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/\son\w+="[^"]*"/gi, "");
};

const ContentWrapper = ({ isInGame, children }) => (
  isInGame ? (
    <Box
      sx={{
        width: "100%",
        mx: "auto",
        px: { xs: 0, sm: 2 },
        maxWidth: { xs: "100%", sm: 600 },
        boxSizing: "border-box",
        minHeight: { xs: "100dvh", sm: "auto" },
        display: "flex",
        flexDirection: "column",
        "& *": { boxSizing: "border-box" },
      }}
    >
      {children}
    </Box>
  ) : (
    <Container maxWidth="sm" sx={{ mt: 1, px: 2, pb: 4 }}>
      {children}
    </Container>
  )
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("App crashed:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, color: "#fff", background: "#111", fontFamily: "monospace" }}>
          <h2>App crashed (ErrorBoundary)</h2>
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {String(this.state.error)}
            {"\n\n"}
            {this.state.error?.stack || ""}
            {"\n\n"}
            {this.state.info?.componentStack || ""}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function AppInner() {
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState('');
  const [isRegistering, setIsRegistering] = useState(false); 
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [gameList, setGameList] = useState([]);
  const [completedGameList, setCompletedGameList] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [currentNodeId, setCurrentNodeId] = useState(null);
  const [gameCode, setGameCode] = useState('');
  const [question, setQuestionText] = useState('');  // Stav pro text otázky
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [connectDialogOpen, setConnectDialogOpen] = useState(false); // Stav pro otevření modálního okna pro propojení hry
  const [gameToConnect, setGameToConnect] = useState(''); // Stav pro uchování kódu hry, kterou je třeba propojit
  const [isInGame, setIsInGame] = useState(false); // Stav pro sledování, zda je uživatel ve hře
  const [isOtherUserGameOpen, setIsOtherUserGameOpen] = useState(false);  // Stav pro modální okno, které informuje o propojení s jiným uživatelem
  const [isLoginOrContinueDialogOpen, setIsLoginOrContinueDialogOpen] = useState(false); // Stav pro modální okno
  const [gameData, setGameData] = useState(null); ; // Stav pro uchování dat
  const [rating, setRating] = useState(''); // Stav pro hodnocení (10 hvězdiček)
  const [hint1, setHint1] = useState(""); // První nápověda
  const [hint2, setHint2] = useState(""); // Druhá nápověda
  const [correctAnswer, setCorrectAnswer] = useState(""); // Správná odpověď
  const [hintStep, setHintStep] = useState(0); // Počet kliknutí na tlačítko
 //  const [gameToConnect, setGameToConnect] = useState('');  // Uchováme kód hry pro propojení  
  //const [otherUserGameLink, setOtherUserGameLink] = useState('');  // Uchováme odkaz na přihlášení pro případ propojení hry
const [imageUrl, setImageUrl] = useState(null);
const [audioUrl, setAudioUrl] = useState(null); // Volitelné audio k otázce
const [storyAudio, setStoryAudio] = useState(null); // Volitelné audio ke story screenům
const [introAudio, setIntroAudio] = useState(null); // Volitelné audio k úvodu
const introAudioRef = useRef(null);
const [introAudioProgress, setIntroAudioProgress] = useState(0);
const [introAudioDuration, setIntroAudioDuration] = useState(0);
const [isIntroAudioPlaying, setIsIntroAudioPlaying] = useState(false);
  const [isNewGame, setIsNewGame] = useState(false);
  const [introText, setIntroText] = useState("");
  const [introGameTitle, setIntroGameTitle] = useState("");
  const [introStartingPlace, setIntroStartingPlace] = useState("");
  const [startTime, setStartTime] = useState(null);
const [elapsedTime, setElapsedTime] = useState(0);

const [isGameCompleted, setIsGameCompleted] = useState(false);
const [endMessage, setEndMessage] = useState(""); 
const [finalRating, setFinalRating] = useState(0);
const [finalElapsedTime, setFinalElapsedTime] = useState(0);
const [isStoryScreen, setIsStoryScreen] = useState(false); // ?? Příběhová obrazovka ANO/NE
const [storyText, setStoryText] = useState(""); // ?? Uložíme příběhový text
const [storyButtonText, setStoryButtonText] = useState("Pokračovat");

const [headline, setHeadline] = useState("");
const [nextInstruction, setNextInstruction] = useState("");
const [voiceSegments, setVoiceSegments] = useState([]);
const [isMultipleChoice, setIsMultipleChoice] = useState(false);
const [isSingleChoice, setIsSingleChoice] = useState(false);
const [hideHintButton, setHideHintButton] = useState(false);
const [choices, setChoices] = useState([]); // Možnosti pro výběr
const [selectedAnswers, setSelectedAnswers] = useState([]); // Uživatelovy odpovědi
const [isRulesOpen, setIsRulesOpen] = useState(false); // ? Stav pro zobrazení pravidel
const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false); // ? Přidáme nový stav pro Leaderboard
const [showExitDialog, setShowExitDialog] = useState(false);
const [showInvalidCodeDialog, setShowInvalidCodeDialog] = useState(false); // ? NOVÝ KÓD
const [showGameConnectedDialog, setShowGameConnectedDialog] = useState(false); // ? NOVÝ KÓD
const [showLoginErrorDialog, setShowLoginErrorDialog] = useState(false); // ? NOVÝ KÓD
const [loginErrorMessage, setLoginErrorMessage] = useState(""); // ? NOVÝ KÓD
const [showRegisterSuccessDialog, setShowRegisterSuccessDialog] = useState(false); // ? NOVÝ KÓD
const [showAnswerDialog, setShowAnswerDialog] = useState(false); // ? NOVÝ KÓD
const [answerDialogMessage, setAnswerDialogMessage] = useState(""); // ? NOVÝ KÓD
const [answerDialogTitle, setAnswerDialogTitle] = useState(""); // ? NOVÝ KÓD
const [showLogoutDialog, setShowLogoutDialog] = useState(false); // ? NOVÝ KÓD
const [showLoginSuccessDialog, setShowLoginSuccessDialog] = useState(false); // ? NOVÝ KÓD
const [showEmailErrorDialog, setShowEmailErrorDialog] = useState(false); // ? NOVÝ KÓD
const [isAccountOpen, setIsAccountOpen] = useState(false);
const [isChangingPassword, setIsChangingPassword] = useState(false); // ? Sleduje, zda se mění heslo
const [currentPassword, setCurrentPassword] = useState(""); // ? Pole pro stávající heslo
const [newPassword, setNewPassword] = useState(""); // ? Pole pro nové heslo
const [showDialog, setShowDialog] = useState(false);  // ? Stav pro zobrazení dialogu
const [dialogMessage, setDialogMessage] = useState("");  // ? Stav pro zprávu v dialogu
const [NazevHry, setGameName] = useState("");  // ? Stav pro zobrazení dialogu
const [avatarUrl, setAvatarUrl] = useState(null);
const [showUploadDialog, setShowUploadDialog] = useState(false);
const [uploading, setUploading] = useState(false);
const [resetToken, setResetToken] = useState("");
const [isResettingPassword, setIsResettingPassword] = useState(false);
const [isRequestingReset, setIsRequestingReset] = useState(false);
const [resetEmail, setResetEmail] = useState("");
const [showLoginRequiredDialog, setShowLoginRequiredDialog] = useState(false);
const [isLastQuestion, setIsLastQuestion] = useState(false);
const [reviewToken, setReviewToken] = useState(null);
const [reviewTokenLoading, setReviewTokenLoading] = useState(false);
const [reviewTokenError, setReviewTokenError] = useState("");
const [showReviewForm, setShowReviewForm] = useState(false);
const [loginIdentifier, setLoginIdentifier] = useState(""); // řízený vstup pro login (email/uživatelské jméno)
const [loginPasswordInput, setLoginPasswordInput] = useState(""); // řízený vstup pro login heslo
const [answerText, setAnswerText] = useState(""); // řízený vstup pro otevřené odpovědi
const [isLoggingIn, setIsLoggingIn] = useState(false); // disable login button při odeslání
const [isSubmittingAnswer, setIsSubmittingAnswer] = useState(false); // disable odeslání odpovědi
const actionLockRef = useRef(false);
const actionCooldownUntilRef = useRef(0);
const [isActionLocked, setIsActionLocked] = useState(false);
const [screenType, setScreenType] = useState(1); // Defaultně 1 (starý vzhled)
const [leaderboardHeroUrl, setLeaderboardHeroUrl] = useState(null);
const [matchAny, setMatchAny] = useState(false);
const [gameHeroUrl, setGameHeroUrl] = useState(null);
const [currentGameId, setCurrentGameId] = useState(null);
const [gameType, setGameType] = useState("outdoor");
const [gameUiConfig, setGameUiConfig] = useState({});
const [isImageOverlayOpen, setIsImageOverlayOpen] = useState(false);
const [allowImageZoom, setAllowImageZoom] = useState(false);

const [decisionStats, setDecisionStats] = useState(null);
const [decisionStatsLoading, setDecisionStatsLoading] = useState(false);
const [decisionStatsError, setDecisionStatsError] = useState(null);
const [activeGameCode, setActiveGameCode] = useState("");
const [confirmPasswordInput, setConfirmPasswordInput] = useState("");

const [showMapIcon, setShowMapIcon] = useState(false);
const [mapImageUrl, setMapImageUrl] = useState(null);
const [isMapOverlayOpen, setIsMapOverlayOpen] = useState(false);
const [activeVoiceId, setActiveVoiceId] = useState(null);
const [isVoicePlaying, setIsVoicePlaying] = useState(false);
const voiceAudioRef = useRef(null);


const [activeTab, setActiveTab] = useState("rozehrane");

const applyGamePresentation = (data) => {
  if (!data || (data.gameType === undefined && data.uiConfig === undefined)) return;
  const presentation = readGamePresentation(data);
  setGameType(presentation.gameType);
  setGameUiConfig(presentation.uiConfig);
};
// Sdílený styl pro audio přehrávač, aby ladil s tmavým boxem
const audioContainerStyle = {
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#1F1F1F",
  border: "1px solid rgba(242, 237, 228, 0.08)",
  borderRadius: "10px",
  padding: "12px",
  marginTop: "14px",
  marginBottom: "16px",
  boxShadow: "0px 4px 24px rgba(242, 237, 228, 0.06)",
};

const landingPaperSx = {
  position: "relative",
  overflowX: "hidden",
  borderRadius: "20px",
  boxSizing: "border-box",
  background: "linear-gradient(180deg, rgba(242, 237, 228, 0.2) 0%, #1A1D22 50.96%), #171A1F",
  border: "0.5px solid #2F353E",
  padding: 4,
  textAlign: "center",
  color: "#F2EDE4",
};

const landingTitleSx = {
  fontFamily: "'Cactus Classical Serif', serif",
  fontSize: "16px",
  color: "#F2EDE4",
  textTransform: "uppercase",
  textAlign: "center",
  letterSpacing: "0.08em",
  mb: 1,
};

const landingDividerSx = {
  height: "1px",
  width: "100%",
  background: "linear-gradient(90deg, rgba(242,237,228,0) 0%, rgba(242,237,228,0.5) 50%, rgba(242,237,228,0) 100%)",
  mb: "20px",
};

const landingTextFieldSx = {
  backgroundColor: "#0F1114",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#0F1114",
    borderRadius: "10px",
    "& fieldset": { borderColor: "#2F353E" },
    "&:hover fieldset": { borderColor: "#2F353E" },
    "&.Mui-focused fieldset": { borderColor: "#F2EDE4" },
  },
  "& .MuiInputBase-input": {
    color: "#F2EDE4",
    fontFamily: "'Cactus Classical Serif', serif",
    fontSize: "16px",
    height: "50px",
    padding: "0 16px",
  },
  "& .MuiInputLabel-root": {
    color: "rgba(242, 237, 228, 0.2)",
    fontFamily: "'Cactus Classical Serif', serif",
    fontSize: "16px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#F2EDE4",
  },
};

const landingButtonSx = {
  width: "100%",
  backgroundColor: "rgba(127, 150, 188, 0.5)",
  color: "#F2EDE4",
  borderRadius: "10px",
  fontFamily: "'Cactus Classical Serif', serif",
  fontSize: "14px",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  paddingTop: "12px",
  paddingBottom: "12px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(127, 150, 188, 0.65)",
    boxShadow: "0 0 10px rgba(127, 150, 188, 0.3)",
  },
};

const dialogPaperSx = {
  position: "relative",
  overflowX: "hidden",
  borderRadius: "16px",
  boxSizing: "border-box",
  background: "linear-gradient(180deg, rgba(242, 237, 228, 0.18) 0%, #1A1D22 60%), #171A1F",
  border: "0.5px solid #2F353E",
  boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.45)",
  color: "#F2EDE4",
};

const dialogTitleSx = {
  fontFamily: "'Cactus Classical Serif', serif",
  textTransform: "uppercase",
  textAlign: "center",
  fontSize: "16px",
  letterSpacing: "0.08em",
  color: "#F2EDE4",
  borderBottom: "1px solid rgba(242, 237, 228, 0.2)",
  paddingBottom: "10px",
};

const dialogButtonSx = {
  backgroundColor: "rgba(127, 150, 188, 0.5) !important",
  color: "#F2EDE4 !important",
  borderRadius: "10px",
  fontFamily: "'Cactus Classical Serif', serif",
  fontSize: "13px",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  padding: "10px 18px",
  boxShadow: "none !important",
  "&:hover": {
    backgroundColor: "rgba(127, 150, 188, 0.65) !important",
    boxShadow: "0 0 10px rgba(127, 150, 188, 0.3) !important",
  },
};

const dialogActionsSx = {
  display: "flex",
  justifyContent: "center",
  gap: 2,
  "& .MuiButton-root": dialogButtonSx,
};

const isGameAnswerFeedbackDialog =
  answerDialogTitle === "Správná odpověď!" || answerDialogTitle === "Špatná odpověď";

// Herní feedback dialogy navazují na plastický vzhled choice tlačítek.
const gameFeedbackDialogPaperSx = {
  width: "min(310px, calc(100% - 28px))",
  m: 1.75,
  position: "relative",
  overflow: "hidden",
  borderRadius: "22px",
  boxSizing: "border-box",
  color: "#F2EDE4",
  background:
    "linear-gradient(180deg, rgba(242,237,228,0.18) 0%, rgba(242,237,228,0.035) 18%, rgba(255,255,255,0) 48%), #1F1F1F",
  border: "1px solid rgba(242,237,228,0.22)",
  boxShadow:
    "inset 0 1px 0 rgba(255,255,255,0.10), inset 0 -20px 40px rgba(0,0,0,0.28), 0 3px 0 #090909, 0 18px 45px rgba(0,0,0,0.62)",
};

const gameFeedbackDialogTitleSx = {
  fontFamily: "'Cactus Classical Serif', serif",
  textTransform: "uppercase",
  textAlign: "center",
  fontSize: { xs: "16px", sm: "17px" },
  lineHeight: 1.35,
  letterSpacing: "0.09em",
  color: "#F2EDE4",
  px: 2,
  pt: 2,
  pb: 0.5,
  borderBottom: "none",
  textShadow: "0 1px 0 rgba(0,0,0,0.7)",
};

const gameFeedbackDialogActionsSx = {
  display: "flex",
  justifyContent: "center",
  px: 2,
  pt: 1.25,
  pb: 1,
};

const gameFeedbackButtonSx = {
  minWidth: 125,
  minHeight: 40,
  px: 2.5,
  borderRadius: "999px",
  backgroundColor: `${gameUiConfig.backgroundColor || "#0E0E0E"} !important`,
  color: "#F2EDE4 !important",
  border: "1px solid rgba(242,237,228,0.24)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.055), 0 2px 0 #070707, 0 7px 16px rgba(0,0,0,0.42)",
  fontFamily: "'Cactus Classical Serif', serif",
  fontSize: "13px",
  fontWeight: 400,
  textTransform: "uppercase",
  letterSpacing: "0.09em",
  transition: "transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease",
  "&:hover": {
    backgroundColor: `${gameUiConfig.backgroundColor || "#0E0E0E"} !important`,
    filter: "brightness(1.28)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.08), 0 2px 0 #070707, 0 9px 20px rgba(0,0,0,0.48)",
  },
  "&:active": {
    transform: "translateY(2px)",
    boxShadow: "inset 0 2px 7px rgba(0,0,0,0.65)",
  },
};


const panel3DSx = {
  position: "relative",
  borderRadius: "24px",
  overflow: "hidden",

  // „lift“ + hlubší stín (to je ten 3D feel)
  boxShadow: "0 22px 65px rgba(0,0,0,0.75)",
  border: "1px solid rgba(242,237,228,0.10)",

  // jemný highlight nahoře
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.02) 30%, rgba(0,0,0,0) 100%)",

  // vnitřní panel + inset shadow (bevel)
  "&::after": {
    content: '""',
    position: "absolute",
    inset: "1px",
    borderRadius: "23px",
    background:
      "linear-gradient(180deg, rgba(242,237,228,0.12) 0%, rgba(242,237,228,0.03) 18%, rgba(0,0,0,0) 65%), #15191F",
    border: "1px solid rgba(255,255,255,0.06)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -18px 40px rgba(0,0,0,0.55)",
    pointerEvents: "none",
    zIndex: 0,
  },
};

const panelSoft3DSx = {
  position: "relative",
  borderRadius: "24px",
  overflow: "hidden",

  // ✅ přirozený stín (ne přestřelený)
  //boxShadow: "0 18px 55px rgba(0,0,0,0.65)",

  // ✅ jedna karta: tmavý základ + lehký top highlight
  background:
    "radial-gradient(120% 90% at 50% 0%, rgba(242,237,228,0.10) 0%, rgba(242,237,228,0.00) 58%), " +
    "linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(0,0,0,0) 55%), " +
    "#15191F",

  // ✅ pouze jedna linka (jako u tabs)
  border: "1px solid rgba(242,237,228,0.10)",

  // ✅ jemný vnitřní shadow pro “hloubku”, ale bez “druhé krabice”
  boxSizing: "border-box",
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    borderRadius: "24px",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -22px 45px rgba(0,0,0,0.55)",
  },
};







const overlayTopMargin = { xs: 7, sm: 4 };


const [questionTimeLeft, setQuestionTimeLeft] = useState(null); // null = netimed
const [questionPenalty, setQuestionPenalty] = useState(0);
const [questionTimed, setQuestionTimed] = useState(false);
const [timeExpiredDialogOpen, setTimeExpiredDialogOpen] = useState(false);

const questionTimerRef = useRef(null);
const timeoutTriggeredRef = useRef(false);
const expiredNodeIdRef = useRef(null);












useEffect(() => {
  // ? NOVÝ KÓD - Načteme uživatelské údaje z localStorage při startu aplikace
  const storedUserId = localStorage.getItem("userId");
  const storedUsername = localStorage.getItem("username");
  const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
  const storedEmail = localStorage.getItem("email"); // ? Přidáno
  const normalizedStoredUserId = Number(storedUserId);

  if (storedIsLoggedIn === "true" && Number.isSafeInteger(normalizedStoredUserId) && normalizedStoredUserId > 0) {
    setUserId(normalizedStoredUserId);
    setUsername(storedUsername);
    setEmail(storedEmail || ""); // ? Přidáno - pokud není email, nastavíme prázdný string
    setIsLoggedIn(true);
    loadUserGames(normalizedStoredUserId);
    loadAvatar(normalizedStoredUserId);
  }
  const params = new URLSearchParams(window.location.search);
const tokenFromUrl = params.get("token");

if (tokenFromUrl) {
  setIsResettingPassword(true);
  setResetToken(tokenFromUrl);
}

}, []);


useEffect(() => {
  if (!startTime || isGameCompleted) return;

  const utcStartTime = new Date(startTime).getTime();

  const updateElapsed = () => {
    const nowUtc = Date.now();
    const elapsed = Math.floor((nowUtc - utcStartTime) / 1000);
    setElapsedTime(elapsed);
  };

  updateElapsed(); // hned po načtení, ne až za 1 s

  const interval = setInterval(updateElapsed, 1000);

  return () => clearInterval(interval);
}, [startTime, isGameCompleted]);

// Pro timed otázky
useEffect(() => {
  if (!questionTimed) return;
  if (questionTimeLeft == null) return;

  if (questionTimeLeft === 0 && !timeoutTriggeredRef.current) {
    timeoutTriggeredRef.current = true;
    expiredNodeIdRef.current = currentNodeId;
    setTimeExpiredDialogOpen(true);
  }
}, [questionTimed, questionTimeLeft, currentNodeId]);


useEffect(() => {
  const loadDecisionStats = async () => {
    try {
      setDecisionStatsLoading(true);
      setDecisionStatsError(null);

     if (!currentGameId) return;
const resp = await fetch(`${API_BASE}/api/games/${currentGameId}/decision-stats`);
      const data = await resp.json();

      if (!resp.ok || !data?.success) {
        throw new Error(data?.error || "Failed to load decision stats");
      }

      setDecisionStats(data);
    } catch (e) {
      console.error(e);
      setDecisionStatsError("Statistiky se nepodařilo načíst.");
      setDecisionStats(null);
    } finally {
      setDecisionStatsLoading(false);
    }
  };

    // ✅ kontrola tady (mimo async), aby se loading nikdy "nezasekl"
  if (isGameCompleted && currentGameId) {
    loadDecisionStats();
  } else {
    // volitelné: když nejsi na konci hry, tak stats vyčisti
    // setDecisionStats(null);
  }

}, [isGameCompleted, currentGameId]);

// recenze
useEffect(() => {
  const generateReviewLink = async () => {
    // Vytáhneme si ten správný kód úplně stejně jako u nápověd
    const codeToUse = activeGameCode || gameCode;

    if (isGameCompleted && userId && codeToUse) {
      setReviewTokenLoading(true);
      setReviewTokenError("");
      try {
        const response = await axios.post("/api/reviews/generate-review-link", {
          user_id: userId,
          gamecode: codeToUse.toUpperCase(), // Zde pošleme ten správný kód
        });
        console.log("? Odpověď od serveru:", response.data);
        setReviewToken(response.data.reviewToken || null);
      } catch (error) {
        console.error("Nepodařilo se získat odkaz pro recenzi:", error);
        setReviewToken(null);
        setReviewTokenError("Hodnocení se nepodařilo načíst.");
      } finally {
        setReviewTokenLoading(false);
      }
    }
  };

  generateReviewLink();
}, [isGameCompleted, userId, gameCode, activeGameCode]); // Nezapomeň přidat activeGameCode sem na konec!

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.has("reviewToken")) {
    setShowReviewForm(true);
  }
}, []);




useEffect(() => {
  const handleBackButton = (event) => {
    event.preventDefault(); // Zabrání navigaci zpět
    setShowExitDialog(true); // Zobrazí potvrzovací okno
  };

  window.addEventListener("popstate", handleBackButton);

  return () => {
    window.removeEventListener("popstate", handleBackButton);
  };
}, []);

  // ? ZACHYTÍME I OKNO PŘED ZAVŘENÍM / OBSAH STRÁNKY
useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isInGame) { // Vykřikne to jen ve hře!
        event.preventDefault();
        event.returnValue = ""; 
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isInGame]); // Nezapomeň přidat do dependencies


  useEffect(() => {
  return () => {
    stopVoicePlayback();
  };
}, []);

  const handleResetPassword = async () => {
    if (!resetToken || !newPassword) {
      alert("Zadej nové heslo.");
      return;
    }
  
    try {
      const response = await fetch(`${API_BASE}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: resetToken, newPassword }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert("Heslo bylo úspěšně změněno.");
        setIsResettingPassword(false);
        setResetToken("");
        setNewPassword("");
        window.history.replaceState(null, "", window.location.pathname);
      } else {
        alert(data.message || "Chyba při změně hesla.");
      }
    } catch (error) {
      console.error("Chyba při změně hesla:", error);
      alert("Chyba při komunikaci se serverem.");
    }
  };
  


  const login = async (identifier, password) => {
    const finalIdentifier = loginIdentifier.trim();
    const finalPassword = loginPasswordInput.trim();
    if (!finalIdentifier || !finalPassword) {
      setLoginErrorMessage("Zadej email nebo název týmu a heslo.");
      setShowLoginErrorDialog(true);
      return;
    }
    setIsLoggingIn(true);
    const response = await fetch(`${backendUrl}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: finalIdentifier, password: finalPassword }),
    });
    const data = await response.json();

    if (data.success) {
      setUserId(data.userId);
      setUsername(data.username);
      setEmail(data.email); // ? Nové – Uložíme email!
      loadAvatar(data.userId);  // ?? NOVÉ: Po přihlášení načti avatar!
      setIsLoggedIn(true);
      loadUserGames(data.userId);
      setIsInGame(false);
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("username", data.username);
      localStorage.setItem("email", data.email); // ? Nové - Uložíme email
      localStorage.setItem("isLoggedIn", "true");
      setShowLoginSuccessDialog(true); // ? NOVÝ KÓD - Zobrazíme dialog pro úspěšné přihlášení

    } else {
      setLoginErrorMessage(data.error); // ? NOVÝ KÓD - Uložíme chybovou zprávu
      setShowLoginErrorDialog(true); // ? NOVÝ KÓD - Zobrazíme dialog
    }
    setIsLoggingIn(false);
  };

const loadAvatar = async (userId) => {
  try {
    const response = await fetch(`${backendUrl}/get-avatar/${userId}`);
    const data = await response.json();
    
    if (response.ok && data.avatarUrl) {
      setAvatarUrl(data.avatarUrl);
      localStorage.setItem("avatarUrl", data.avatarUrl);
    } else {
      setAvatarUrl(null);
      localStorage.removeItem("avatarUrl");
    }
  } catch (error) {
    console.error("Chyba při načítání avatara:", error);
    setAvatarUrl(null);
    localStorage.removeItem("avatarUrl");
  }
};
  

  

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // ? REGEX pro validaci e-mailu
    return emailRegex.test(email);
  };

 const register = async (username, email, loginPasswordInput, confirmPasswordInput) => {
  if (!username || !email || !loginPasswordInput || !confirmPasswordInput) {
    setLoginErrorMessage("Vyplň prosím název týmu, email, heslo a potvrzení hesla.");
    setShowLoginErrorDialog(true);
    return;
  }

  if (!isValidEmail(email)) {
    setShowEmailErrorDialog(true);
    return;
  }

  if (loginPasswordInput !== confirmPasswordInput) {
    setLoginErrorMessage("Hesla se neshodují.");
    setShowLoginErrorDialog(true);
    return;
  }

  const response = await fetch(`${backendUrl}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username,
      email,
      password: loginPasswordInput,
      confirmPassword: confirmPasswordInput,
    }),
  });

  const data = await response.json();

  if (data.success) {
    setShowRegisterSuccessDialog(true);
    setIsLoggedIn(false);
    setIsInGame(false);
    setIsRegistering(false);
  } else {
    setLoginErrorMessage(data.error);
    setShowLoginErrorDialog(true);
  }
};

  const loadUserGames = async (userId) => {
    const response = await fetch(`${backendUrl}/my-progress/${userId}`);
    const data = await response.json();
    console.log('Loaded progress data:', data.progress);  // Logování pro kontrolu, co se vrací
    if (response.ok && data.success) {
      console.log('Progress data:', data.progress); // Log pro zjištění, co je v datech
      setGameList(data.progress.rows.filter(game => !game.is_completed));
      setCompletedGameList(data.progress.rows.filter(game => game.is_completed));
    } else {
      console.log('Žádné rozehrané hry nebyly nalezeny.');
    }
  };

  const renderNextInstructionSection = () => {
  if (!nextInstruction && !(showMapIcon && mapImageUrl)) return null;

  return (
    <>
      {nextInstruction && (
        <>
          <Box
            sx={{
              height: "1px",
              width: "min(720px, 92%)",
              background:
                "linear-gradient(to right, rgba(242,237,228,0) 0%, rgba(242,237,228,0.45) 50%, rgba(242,237,228,0) 100%)",
              boxShadow: "0 0 12px rgba(242,237,228,0.2)",
              mx: "auto",
              mt: 2,
              mb: 2,
              opacity: 0.9,
            }}
          />

          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-line",
              fontFamily: "'Cactus Classical Serif', serif",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "23px",
              textAlign: "center",
              color: "rgba(255, 255, 255, 0.82)",
              mb: showMapIcon && mapImageUrl ? 1 : 2,
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(nextInstruction) }}
          />
        </>
      )}

      {showMapIcon && mapImageUrl && (
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <IconButton
            aria-label="Otevřít mapu"
            onClick={(e) => {
              e.stopPropagation();
              setIsMapOverlayOpen(true);
            }}
            disableRipple
            sx={{
              width: 48,
              height: 48,
              color: "#F2EDE4",
              background:
                "linear-gradient(180deg, rgba(242,237,228,0.08) 0%, rgba(0,0,0,0.18) 100%)",
              border: "1px solid rgba(242,237,228,0.12)",
              boxShadow: "0 4px 20px rgba(0,0,0,0.35)",
              "&:hover": {
                background:
                  "linear-gradient(180deg, rgba(242,237,228,0.12) 0%, rgba(0,0,0,0.24) 100%)",
              },
            }}
          >
            <MapOutlinedIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Box>
      )}
    </>
  );
};

const renderMapOverlay = () => {
  if (!isMapOverlayOpen || !mapImageUrl) return null;

  return (
    <Box
      onClick={() => setIsMapOverlayOpen(false)}
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 30,
        backgroundColor: "rgba(0, 0, 0, 0.74)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 1.5, sm: 2.5 },
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "560px",
          maxHeight: "85%",
          borderRadius: "18px",
          overflow: "hidden",
          backgroundColor: "#111",
          border: "1px solid rgba(242,237,228,0.12)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
        }}
      >
        <IconButton
          onClick={() => setIsMapOverlayOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            color: "#F2EDE4",
            backgroundColor: "rgba(0,0,0,0.45)",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.65)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          component="img"
          src={mapImageUrl}
          alt="Mapa"
          sx={{
            display: "block",
            width: "100%",
            height: "auto",
            maxHeight: "85dvh",
            objectFit: "contain",
            backgroundColor: "#0E0E0E",
          }}
        />
      </Box>
    </Box>
  );
};

const renderImageOverlay = () => {
  const canOpenImageOverlay = screenType === 1 || (screenType === 2 && allowImageZoom);
  if (!isImageOverlayOpen || !imageUrl || !canOpenImageOverlay) return null;

  return (
    <Box
      onClick={() => setIsImageOverlayOpen(false)}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.72)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 1.5, sm: 3 },
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: "relative",
          display: "inline-flex",
          width: "100%",
          maxWidth: { xs: "96vw", sm: "760px" },
          maxHeight: "88dvh",

          "@media (orientation: landscape)": {
            width: "fit-content",
            maxWidth: "94vw",
            maxHeight: "86dvh",
          },
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Detail obrázku"
          sx={{
            display: "block",
            width: "100%",
            maxWidth: { xs: "96vw", sm: "760px" },
            maxHeight: "88dvh",
            objectFit: "contain",
            borderRadius: { xs: "12px", sm: "18px" },
            boxShadow: "0 24px 80px rgba(0,0,0,0.75)",
            border: "1px solid rgba(242,237,228,0.12)",

            "@media (orientation: landscape)": {
              width: "auto",
              maxWidth: "94vw",
              maxHeight: "86dvh",
            },
          }}
        />
        <IconButton
          aria-label="Zavřít obrázek"
          onClick={(e) => {
            e.stopPropagation();
            setIsImageOverlayOpen(false);
          }}
          sx={{
            position: "absolute",
            top: { xs: 8, sm: 10 },
            right: { xs: 8, sm: 10 },
            zIndex: 1,
            color: "#F2EDE4",
            backgroundColor: "rgba(0,0,0,0.55)",
            border: "1px solid rgba(242,237,228,0.18)",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.75)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

const renderScreenType2ImageZoomButton = () => {
  if (screenType !== 2 || !allowImageZoom || !imageUrl) return null;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
        zIndex: 3,
        px: { xs: 1, sm: 1.5 },
        mb: { xs: 0.5, sm: 0.75 },
      }}
    >
      <IconButton
        aria-label="Zvětšit ilustraci"
        title="Zvětšit ilustraci"
        onClick={(e) => {
          e.stopPropagation();
          setIsImageOverlayOpen(true);
        }}
        sx={{
          width: 42,
          height: 42,
          color: "#F2EDE4",
          backgroundColor: "rgba(0,0,0,0.62)",
          border: "1px solid rgba(242,237,228,0.22)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.45)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.78)",
          },
        }}
      >
        <ZoomInIcon sx={{ fontSize: 24 }} />
      </IconButton>
    </Box>
  );
};

const stopVoicePlayback = () => {
  if (voiceAudioRef.current) {
    voiceAudioRef.current.pause();
    voiceAudioRef.current.currentTime = 0;
    voiceAudioRef.current.onended = null;
    voiceAudioRef.current = null;
  }

  setActiveVoiceId(null);
  setIsVoicePlaying(false);
};

const toggleVoicePlayback = async (segment) => {
  if (!segment?.url) return;

  // klik na právě aktivní hlas = play/pause
  if (activeVoiceId === segment.id && voiceAudioRef.current) {
    if (isVoicePlaying) {
      voiceAudioRef.current.pause();
      setIsVoicePlaying(false);
    } else {
      try {
        await voiceAudioRef.current.play();
        setIsVoicePlaying(true);
      } catch (err) {
        console.error("Chyba při spuštění voice audio:", err);
      }
    }
    return;
  }

  // jiný hlas = stop starého + play nového
  stopVoicePlayback();

  try {
    const audio = new Audio(segment.url);
    voiceAudioRef.current = audio;
    setActiveVoiceId(segment.id);

    audio.onended = () => {
      setIsVoicePlaying(false);
      setActiveVoiceId(null);
      voiceAudioRef.current = null;
    };

    await audio.play();
    setIsVoicePlaying(true);
  } catch (err) {
    console.error("Chyba při spuštění voice audio:", err);
    stopVoicePlayback();
  }
};

const resetGameSessionState = () => {
  actionLockRef.current = false;
actionCooldownUntilRef.current = 0;
setIsActionLocked(false);
  stopVoicePlayback();
  // question timer
  if (questionTimerRef.current) {
    clearInterval(questionTimerRef.current);
    questionTimerRef.current = null;
  }
  timeoutTriggeredRef.current = false;

  // global game timer
  setStartTime(null);
  setElapsedTime(0);
 

  // active game identity
  setActiveGameCode("");
  setGameCode("");
  setCurrentGameId(null);
  setGameType("outdoor");
  setGameUiConfig({});
  setCurrentQuestion(null);

  // game flow
  setIsInGame(false);
  setIsNewGame(false);
  setIsGameCompleted(false);
  setIsLastQuestion(false);

  // screen/question content
  setQuestionText("");
  setStoryText("");
  setStoryButtonText("Pokračovat");
  setHeadline("");
  setNextInstruction("");
  setImageUrl(null);
  setAudioUrl(null);
  setStoryAudio(null);
  setIntroAudio(null);
  setChoices([]);
  setSelectedAnswers([]);
  setAnswerText("");

  // hint/timed-question state
  setHint1("");
  setHint2("");
  setCorrectAnswer("");
  setHintStep(0);
  setQuestionTimed(false);
  setQuestionTimeLeft(null);
  setQuestionPenalty(0);
  setTimeExpiredDialogOpen(false);

 // reset hint mapy
  setShowMapIcon(false);
setMapImageUrl(null);
setIsMapOverlayOpen(false);
setIsImageOverlayOpen(false); 
setAllowImageZoom(false);
 // reset audio
setVoiceSegments([]);

  // optional cleanup
  setDecisionStats(null);
  setDecisionStatsError(null);
  setReviewToken(null);
  setReviewTokenLoading(false);
  setReviewTokenError("");
};


  const submitGameCode = async () => {
  if (!isLoggedIn) {
    setShowLoginRequiredDialog(true);
    return;
  }

  console.log("Odesílám kód hry:", gameCode);
  const normalizedGameCode = gameCode.toUpperCase();

  const response = await fetch(`${backendUrl}/verify-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code: normalizedGameCode, userId }),
  });

  const data = await response.json();
  console.log("Odpověď z backendu:", data);
  setGameData(data);
  console.log("GameData po nastavení:", data);

  if (data.error) {
    if (data.action === 'connect') {
      setGameToConnect(normalizedGameCode);
      setConnectDialogOpen(true);
    } else if (data.action === 'login_or_continue') {
      setGameToConnect(normalizedGameCode);
      setIsLoginOrContinueDialogOpen(true);
    } else if (data.link) {
      setIsOtherUserGameOpen(true);
    } else {
      setShowInvalidCodeDialog(true);
    }
  } else {
  resetGameSessionState();
  applyGamePresentation(data);

  setIsInGame(true);
  setCurrentQuestion(data.currentQuestion);
  setActiveGameCode(normalizedGameCode);
  setGameCode("");

  if (data.gameType === "escape_box" && data.isGameStarted) {
    setCurrentGameId(data.gameId || null);
    setIsNewGame(false);
    return;
  }

  if (data.isGameCompleted === true) {
    await loadQuestion(normalizedGameCode, data.currentQuestion);
    return;
  }

  loadQuestion(normalizedGameCode, data.currentQuestion);
}
};

// Když kliknete na "Pokračovat bez přihlášení"

const resetTimedQuestionState = () => {
  // zastavit starý interval
  if (questionTimerRef.current) {
    clearInterval(questionTimerRef.current);
    questionTimerRef.current = null;
  }

  // reset UI / state
  setTimeExpiredDialogOpen(false);
  setQuestionTimed(false);
  setQuestionTimeLeft(null);
  setQuestionPenalty(0);

  // 🔥 nejdůležitější: povolit další timeout trigger
  timeoutTriggeredRef.current = false;
};




  const loadQuestion = async (gameCode,questionId) => {
    const normalized = gameCode ? gameCode.toUpperCase() : gameCode;
    if (!normalized || !questionId) {
      console.error("gameCode nebo questionId není definováno");
      return;   }
    console.log("Načítám otázku pro kód hry:", normalized, "a aktuální otázku:", questionId);  // Log pro kontrolu
    //console.log("?? Načítám startTime do state:", data.startTime);
    stopVoicePlayback();
    setIsImageOverlayOpen(false);

    const response = await fetch(`${backendUrl}/question/${normalized}?questionId=${questionId}`);
    const data = await response.json();
    applyGamePresentation(data);
  if (data?.gameId) {
  setCurrentGameId(data.gameId);
}
    console.log("?? Odpověď z backendu pro poslední otázku:", data);

    // ✅ VŽDY vypni starý question timer při každém loadu
if (questionTimerRef.current) {
  clearInterval(questionTimerRef.current);
  questionTimerRef.current = null;
}
timeoutTriggeredRef.current = false;
setQuestionTimed(false);
setQuestionPenalty(0);
setQuestionTimeLeft(null);


    if (response.ok) {
    
  
      if (data.isNewGame) {
        // ? Pokud je hra nová, zobrazíme úvodní obrazovku
        setIsGameCompleted(false);
        setIsNewGame(true);
        setAllowImageZoom(false);
        setIntroText(data.introscreentext || "");
        setImageUrl(data.introscreenimage || null); // Načteme úvodní obrázek
        setIntroAudio(data.introscreenaudio || null);
        setIntroGameTitle(data.gameName || data.NazevHry || gameData?.gameName || "");
        setIntroStartingPlace(data.IntroStartingPlace || data.introstartingplace || "");
        setStoryAudio(null);
        setAudioUrl(null);
        setVoiceSegments([]);
        setGameHeroUrl(data.introscreenimage || null);
         setStartTime(null);
setElapsedTime(0);

        return; // Nechceme pokračovat dál, dokud hráč nezačne hru
      }
  
      setIsNewGame(false); // Pokud progress existuje, vypneme úvodní obrazovku
      setIsGameCompleted(false); // ?? Resetujeme isGameCompleted při načítání nové hry
      setScreenType(data.screenType || 1);
      setAllowImageZoom(!!data.allowImageZoom);
      setIsStoryScreen(data.isStoryScreen || false); // ?? Nastavení, zda jde o příběhovou obrazovku
      setStoryText(data.storyText || ""); // ?? Uložíme text příběhu (opraveno!)
      setStoryButtonText(
        typeof data.storyButtonText === "string" && data.storyButtonText.trim()
          ? data.storyButtonText.trim()
          : "Pokračovat"
      );

      setHeadline(data.headline || "");
      setNextInstruction(data.next_instruction || "");
      setVoiceSegments(Array.isArray(data.voiceSegments) ? data.voiceSegments : []);
      setShowMapIcon(!!data.showMapIcon);
      setMapImageUrl(data.mapImageUrl || null);
      setIsMapOverlayOpen(false);
      setGameName(data.NazevHry);
      setRating(data.rating);
      setIntroAudio(data.introscreenaudio || null); // Úvodní audio (pokud je)
      if (data.introscreenimage) setGameHeroUrl(data.introscreenimage);

      console.log("?? Kontroluji isGameCompleted:", data.isGameCompleted);
      if (data.isGameCompleted) {
        // Pokud je hra dokončena, nastavíme správnou zprávu
        console.log("?? Hra dokončena! Přepínám na finální obrazovku.");
        setIsGameCompleted(true);
        setEndMessage(data.message); 
        setFinalRating(data.rating);
        setFinalElapsedTime(data.elapsedTime);
        setVoiceSegments([]);
        setIntroGameTitle(data.gameName || data.NazevHry || gameData?.gameName || "");
        console.log("SETTING introGameTitle TO:", data.gameName || data.NazevHry || gameData?.gameName || "");
         setGameHeroUrl(data.introscreenimage || null);
        return;
      }   console.log("AFTER completed check - introGameTitle state currently:", introGameTitle);
      if (data.startTime) {
  console.log("⏱️ Obnovuji startTime:", data.startTime);
  setStartTime(data.startTime);

}
          if (data.isStoryScreen) {
        console.log("?? Příběhová obrazovka detekována!");
        setIsStoryScreen(true);
        setIsLastQuestion(data.isLastQuestion || false); // SMAZAT
        setStoryText(sanitizeHtml(data.storyText) || "");
        setImageUrl(data.storyImage || null);
        setStoryAudio(data.storyAudio || null);
        setAudioUrl(null);
        setAnswerText("");
        setCurrentQuestion(questionId);  // ? Uložit číslo aktuální otázky i pro story screen
        setIsSingleChoice(false); // ? Story obrazovky jsou vždy bez výběru
        setHideHintButton(false); // ? Nápověda je pro story obrazovky vždy dostupná (nebo ji můžeme skrýt, pokud chceš)
        setMatchAny(false);

      
       
      } else {
        // Pokud je hra stále aktivní, nastavíme otázku a číslo otázky
        resetTimedQuestionState();
        setIsMultipleChoice(data.isMultipleChoice  || false);
        setMatchAny(!!data.match_any || !!data.matchAny);
        setIsSingleChoice(!!data.isSingleChoice);
        setHideHintButton(!!data.hideHintButton);
        setChoices(data.choices || []);
        setSelectedAnswers([]); // Reset výběru
        console.log("isMultipleChoice (backend):", data.isMultipleChoice );
        console.log("isMultipleChoice (frontend):", isMultipleChoice);
        console.log("?? Ukládám otázku:", data.currentQuestion);
        setIsStoryScreen(false);
        setCurrentQuestion(data.currentQuestion);  
        setCurrentNodeId(data.currentNodeId || null);
        setQuestionText(sanitizeHtml(data.question));  // Uložení textu otázky do stavu
        setRating(data.rating); // Nastavíme hodnocení z backendu
        setHint1(data.hint_1 || "Nápověda není dostupná.");
        setHint2(data.hint_2 || "Druhá nápověda není dostupná.");
        setCorrectAnswer(data.correctAnswer);
        setStoryAudio(null);
        setAudioUrl(data.audioUrl || null);
        setAnswerText("");
   
    
        if (data.startTime) {
          console.log("?? Nastavuji startTime na:", data.startTime);
          setStartTime(data.startTime); // ? Správně nastavený čas z backendu
        }

          // ?? Rozhodneme, jestli resetovat nápovědy nebo je načíst
          if (data.usedHints !== undefined) {
            console.log("?? Načítám uložené nápovědy:", data.usedHints);
            setHintStep(data.usedHints);  // Správně obnoví nápovědy pro rozehranou hru
        } else {
            console.log("?? Resetuji nápovědy pro novou hru");
            setHintStep(0);  // Resetuje nápovědy jen při nové hře
        }
 



    setImageUrl(data.imageUrl || null);
    setAnswerText("");
 
// ✅ TIMED QUESTION: setup jen pro question screen (ne story)
const limit = data.time_limit_seconds;
const penalty = data.wrong_time_penalty_seconds ?? 0;

if (limit != null) {
  setQuestionTimed(true);
  setQuestionPenalty(Number(penalty));
  setQuestionTimeLeft(Number(limit));

  questionTimerRef.current = setInterval(() => {
    setQuestionTimeLeft((prev) => {
      if (prev == null) return prev;
      if (prev <= 1) {
        clearInterval(questionTimerRef.current);
        questionTimerRef.current = null;
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
}
console.log("⏳ TIMED:", data.time_limit_seconds, "penalty:", data.wrong_time_penalty_seconds);

      }
    } else {
      unlockGameAction({ withCooldown: false });
      alert('Chyba při načítání otázky');
    }
  };

  const handleRequestReset = async () => {
    try {
      const response = await fetch("/auth/request-password-reset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: resetEmail }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert("Na e-mail jsme ti poslali odkaz pro obnovení hesla.");
        setIsRequestingReset(false);
      } else {
        alert(data.message || "Chyba při odesílání požadavku.");
      }
    } catch (error) {
      console.error("Chyba při žádosti o reset hesla:", error);
      alert("Něco se pokazilo.");
    }
  };

  const ACTION_POST_LOAD_COOLDOWN_MS = 500;

const isActionCurrentlyLocked = () => {
  if (actionLockRef.current) return true;
  return Date.now() < actionCooldownUntilRef.current;
};

const lockGameAction = () => {
  actionLockRef.current = true;
  setIsActionLocked(true);
};

const unlockGameAction = ({ withCooldown = true } = {}) => {
  actionLockRef.current = false;
  actionCooldownUntilRef.current = withCooldown
    ? Date.now() + ACTION_POST_LOAD_COOLDOWN_MS
    : 0;
  setIsActionLocked(false);
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  
  const handleTimeoutContinue = async () => {
    const codeToUse = (activeGameCode || gameCode || "").toUpperCase();
  setTimeExpiredDialogOpen(false);

  // vypni timer (pro jistotu)
  if (questionTimerRef.current) {
    clearInterval(questionTimerRef.current);
    questionTimerRef.current = null;
  }
  setQuestionTimed(false);
  setQuestionPenalty(0);
  setQuestionTimeLeft(null);

  const response = await fetch(`${backendUrl}/timeout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      code: codeToUse,
      userId: userId,
      expectedNodeId: expiredNodeIdRef.current,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("Timeout failed:", data);
    return;
  }

  // teď znovu načti otázku - server už přepnul current_node_id v progress
  await loadQuestion(codeToUse, currentQuestion || 1);
};


  const startNewGame = async () => {
  if (isActionCurrentlyLocked()) {
    return;
  }

  lockGameAction();

  try {
    const codeToUse = (activeGameCode || gameCode || "").toUpperCase();

    const response = await fetch(`${backendUrl}/start-game`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code: codeToUse }),
    });

    const data = await response.json();

    if (response.ok && data.success) {
      setStartTime(data.startTime);
      setIsNewGame(false);

      if (gameType !== "escape_box") {
        await loadQuestion(codeToUse, 1);
      }
      await sleep(ACTION_POST_LOAD_COOLDOWN_MS);
    } else {
      alert("Chyba při startu hry: " + data.error);
      unlockGameAction({ withCooldown: false });
      return;
    }
  } catch (error) {
    console.error("Chyba při startu hry:", error);
    unlockGameAction({ withCooldown: false });
    return;
  }

  unlockGameAction();
};




const handleContinueGame = (game) => {
  const normalizedCode = game.code.toUpperCase();
  const { current_question } = game;

  resetGameSessionState();
  setIsInGame(true);
  setActiveGameCode(normalizedCode);
  setGameCode(""); // input nech prázdný
  applyGamePresentation({ gameType: game.game_type, uiConfig: game.ui_config });
  setCurrentGameId(game.game_id || null);

  if (game.game_type !== "escape_box") {
    loadQuestion(normalizedCode, current_question);
  }
};

  const handleLoginOrContinue = () => {
    setIsLoginOrContinueDialogOpen(false);  // Zavře modální okno
    setUserId(null);  // Pokračuje s userId = null
    setIsInGame(true);  // Pokračuje ve hře
    const normalizedCode = (gameCode || gameToConnect || "").toUpperCase();
    setActiveGameCode(normalizedCode);
    applyGamePresentation(gameData);
    setCurrentGameId(gameData.gameId || null);
    console.log("gameData na začátku handleLoginOrContinue:", gameData); // Log pro kontrolu

    if (gameData.gameType === "escape_box") {
      setIsNewGame(false);
      return;
    }
    
    // Ujistíme se, že máme správné hodnoty v gameData
    if (gameData.currentQuestion !== undefined && gameData.currentQuestion !== null) {
      console.log("Načítámee otázku pro kód hry:", gameCode, "a aktuální otázku:", gameData.currentQuestion);
      loadQuestion(normalizedCode, gameData.currentQuestion);  // Načteme první otázku pro hru podle gameData
    }
  };

  const handleSelectAnswer = (option) => {
    setSelectedAnswers((prev) =>
      prev.includes(option) ? prev.filter((ans) => ans !== option) : [...prev, option]
    );
  };



 const submitAnswer = async (customAnswer = null) => {
  if (isActionCurrentlyLocked()) {
    return;
  }

  lockGameAction();
  setIsSubmittingAnswer(true);

  // ✅ defaultně necháme krátký cooldown po dokončení akce,
  // ale u validační chyby / serverové chyby ho vypneme
  let shouldUseCooldown = true;

  try {
    const answer = customAnswer !== null
      ? customAnswer
      : (isMultipleChoice ? selectedAnswers.join(",") : answerText);

    //const answer = isStoryScreen ? "story_screen" : document.getElementById('answerInput').value;

    if (!isStoryScreen && (!answer || (isMultipleChoice && selectedAnswers.length === 0))) {
      setAnswerDialogTitle("Chybějící odpověď");
      setAnswerDialogMessage("Prosím, zadejte odpověď.");
      setShowAnswerDialog(true);
      shouldUseCooldown = false;
      return;
    }

    const codeToUse = (activeGameCode || gameCode || "").toUpperCase();
    console.log("Odesílám kód:", codeToUse, "Uživatel:", userId, "Odpověď:", answer); //

    const response = await fetch(`${backendUrl}/submit-answer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: codeToUse,
        userId: userId,
        answer: answer
      }),
    });

    const data = await response.json();
    if (data?.gameId) {
      setCurrentGameId(data.gameId);
    }
    console.log("Odpověď z backendu:", data);

    if (response.ok) {
      if (data.isGameCompleted) {
        console.log("?? Hra dokončena! Přepínám na finální obrazovku.");
        setIsGameCompleted(true);
        setEndMessage(data.message || "Gratulujeme k dokončení hry!");
        setFinalRating(data.rating || 10);
        setFinalElapsedTime(data.elapsedTime || 0);

        return;  // ?? Ukončíme funkci, aby už neprobíhala další logika
      }

      if (data.correct) {
        if (!isStoryScreen && !matchAny) { // ?? Story screen nemá alert
          setAnswerDialogTitle("Správná odpověď!"); // ? NOVÝ KÓD
          setAnswerDialogMessage("Vaše odpověď je správná!"); // ? NOVÝ KÓD
          setShowAnswerDialog(true); // ? NOVÝ KÓD
        }

        if (data.nextQuestion) {
          console.log("?? Nastavuji nextQuestion na:", data.nextQuestion);
          setCurrentQuestion(data.nextQuestion);
          setSelectedAnswers([]); // Resetujeme výběr odpovědí
          resetTimedQuestionState();
          await loadQuestion(codeToUse, data.nextQuestion);
        } else {
          console.log("? Chyba: Backend neposlal nextQuestion");
        }

        // App.js
        // ...
      } else {
        // ZDE JE KLÍČOVÁ ZMĚNA: Kontrolujeme nový příznak z backendu
        if (data.wasMultipleChoice) {
          // ✅ TIMED MULTIPLE CHOICE: jen časová penalizace, žádné hvězdy, žádný dialog
          if (questionTimed && questionTimeLeft != null && isMultipleChoice) {
            setQuestionTimeLeft((prev) => {
              if (prev == null) return prev;
              const next = Math.max(0, prev - (questionPenalty || 0));
              return next;
            });

            // Volitelné: krátká hláška v konzoli
            console.log(`⏳ Wrong answer → -${questionPenalty}s`);
            setAnswerDialogTitle("Špatná odpověď");
            setAnswerDialogMessage(`Odpověď není správná. Ztrácíte ${questionPenalty || 0} s z celkového času pro tuto otázku.`);
            setShowAnswerDialog(true);

            return; // ⛔️ TÍMTO ZABRÁNÍŠ staré logice (hvězdy/dialogy)
          }

          // Pokud byla odpověď špatná u multiple-choice otázky
          setAnswerDialogTitle("Špatná odpověď");
          setAnswerDialogMessage("Odpověď není správná a ztrácíte půl hvězdičky. Zkuste to znovu!");

          // Znovu použijeme ověřenou logiku z funkce useHint()
          const newRating = Math.max(rating - 0.5, 0);
          setRating(newRating); // Aktualizujeme hodnocení lokálně

          // A odešleme změnu na backend, aby se uložila
          fetch(`${backendUrl}/update-rating`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code: codeToUse ? codeToUse.toUpperCase() : codeToUse, rating: newRating }) // OPRAVENO
          });

        } else {
          // Standardní chování pro špatnou textovou odpověď
          setAnswerDialogTitle("Špatná odpověď");
          setAnswerDialogMessage("Odpověď není správná. Zkuste to znovu!");
        }

        setShowAnswerDialog(true); // Zobrazíme dialog v obou případech
      }
    } else {
      // ...
      shouldUseCooldown = false;
      setAnswerDialogTitle("Chyba při odesílání"); // ? NOVÝ KÓD
      setAnswerDialogMessage("Nastala chyba při odesílání odpovědi."); // ? NOVÝ KÓD
      setShowAnswerDialog(true); // ? NOVÝ KÓD
    }
  } catch (error) {
    console.error("Chyba při odesílání odpovědi:", error);
    shouldUseCooldown = false;
    setAnswerDialogTitle("Chyba při odesílání");
    setAnswerDialogMessage("Nastala chyba při odesílání odpovědi.");
    setShowAnswerDialog(true);
  } finally {
    setIsSubmittingAnswer(false);
    unlockGameAction({ withCooldown: shouldUseCooldown });
  }
};

  const logout = () => {
    resetGameSessionState();
    setUserId(null);
    setUsername('');
    setIsLoggedIn(false);
    setIsRegistering(false);
    setEmail('');
    setPassword('');
    setIsInGame(false);
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email"); // ? Nové
    localStorage.removeItem("avatarUrl");
    setShowLogoutDialog(true); // ? NOVÝ KÓD
  };


 const QuitSave = () => {
  console.log("Ukládám pokrok ve hře...");

  resetGameSessionState();

  console.log("UUUUUkládám pokrok ve hře...,", userId);
  loadUserGames(userId);
};

  const connectGameToAccount = async (gameCode, userId) => {
    const response = await fetch(`${backendUrl}/connect-game`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: gameCode ? gameCode.toUpperCase() : gameCode, userId }),
    });
  
    const data = await response.json();
  
    if (data.success) {
      setShowGameConnectedDialog(true);
      loadUserGames(userId);  // Načteme hry znovu, aby se aktualizoval stav
    } else {
      alert('Chyba při propojení hry.');
    }
  };

  const handleConnectDialogClose = (connect) => {
    setConnectDialogOpen(false);
    if (connect) {
      // Pokud uživatel chce propojit účet
      connectGameToAccount(gameToConnect, userId);
    }
  };
  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword) {
      setShowDialog(true);
      setDialogMessage("Vyplňte obě pole pro změnu hesla.");
      return;
    }
  
    try {
      const response = await fetch(`${backendUrl}/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          currentPassword,
          newPassword
        }),
      });
  
      const data = await response.json();
  
      if (data.success) {
        setShowDialog(true);
        setDialogMessage("Heslo bylo úspěšně změněno.");
        setIsChangingPassword(false);
        setCurrentPassword("");
        setNewPassword("");
      } else {
        setShowDialog(true);
        setDialogMessage(data.error || "Chyba při změně hesla.");
      }
    } catch (error) {
      setShowDialog(true);
      setDialogMessage("Chyba serveru. Zkuste to znovu.");
    }
  };

  const ICON_STAR = "\u2605";
  const ICON_STOPWATCH = "\u23F1";
  const STAR_SIZE = 20;
  const STAR_GAP = 5;

  const StarSvg = ({ variant }) => {
    const starId = `star-grad-${variant}`;
    const glowId = `star-glow-${variant}`;

    return (
      <svg
        width={STAR_SIZE}
        height={STAR_SIZE}
        viewBox="0 0 24 24"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <defs>
          <linearGradient id={starId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFF1A6" stopOpacity="1" />
            <stop offset="38%" stopColor="#F6D15A" stopOpacity="1" />
            <stop offset="100%" stopColor="#C99210" stopOpacity="1" />
          </linearGradient>
          <filter id={glowId} x="-30%" y="-30%" width="160%" height="160%">
            <feDropShadow dx="0" dy="2" stdDeviation="0" floodColor="rgba(0,0,0,0.65)" />
            <feDropShadow dx="0" dy="0" stdDeviation="4" floodColor="rgba(246,209,90,0.18)" />
          </filter>
          <clipPath id={`${starId}-half`}>
            <rect x="0" y="0" width="12" height="24" />
          </clipPath>
        </defs>
        {variant === "full" && (
          <path
            d="M12 2.4l2.9 6 6.6.9-4.8 4.5 1.2 6.6-5.9-3.1-5.9 3.1 1.2-6.6-4.8-4.5 6.6-.9L12 2.4z"
            fill={`url(#${starId})`}
            filter={`url(#${glowId})`}
          />
        )}
        {variant === "empty" && (
          <path
            d="M12 2.4l2.9 6 6.6.9-4.8 4.5 1.2 6.6-5.9-3.1-5.9 3.1 1.2-6.6-4.8-4.5 6.6-.9L12 2.4z"
            fill="rgba(210,210,210,0.38)"
            filter="drop-shadow(0 1px 0 rgba(0,0,0,0.65))"
          />
        )}
        {variant === "half" && (
          <>
            <path
              d="M12 2.4l2.9 6 6.6.9-4.8 4.5 1.2 6.6-5.9-3.1-5.9 3.1 1.2-6.6-4.8-4.5 6.6-.9L12 2.4z"
              fill="rgba(210,210,210,0.38)"
              filter="drop-shadow(0 1px 0 rgba(0,0,0,0.65))"
            />
            <path
              d="M12 2.4l2.9 6 6.6.9-4.8 4.5 1.2 6.6-5.9-3.1-5.9 3.1 1.2-6.6-4.8-4.5 6.6-.9L12 2.4z"
              fill={`url(#${starId})`}
              clipPath={`url(#${starId}-half)`}
              filter={`url(#${glowId})`}
            />
          </>
        )}
      </svg>
    );
  };
  const renderStars = () => {
    console.log("? Debugging renderStars() - rating:", rating);
    const fullStars = Math.floor(rating); // PoŽ›et plnÆñch hvŽ>zd
    const hasHalfStar = rating % 1 !== 0; // MÆó bÆñt poloviŽ›nÆð hvŽ>zda?
    const emptyStars = 10 - fullStars - (hasHalfStar ? 1 : 0); // PoŽ›et prÆózdnÆñch hvŽ>zd

    if (isStoryScreen) {
      console.log("?? Debug: isStoryScreen aktivnÆð!");
      console.log("?? Game Name:", NazevHry);
      console.log("?? Rating:", rating);
      console.log("?? Elapsed Time:", elapsedTime);
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          marginTop: "0px",
          paddingTop: "0px",
          letterSpacing: "0px",
          fontFamily: "initial",
          textTransform: "none",
          lineHeight: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2px",
            transform: "translateY(-1px)",
          }}
        >
          {Array(fullStars).fill(null).map((_, index) => (
            <span key={`full-${index}`} style={{ display: "inline-flex" }}>
              <StarSvg variant="full" />
            </span>
          ))}

          {hasHalfStar && (
            <span key="half" style={{ display: "inline-flex" }}>
              <StarSvg variant="half" />
            </span>
          )}

          {Array(emptyStars).fill(null).map((_, index) => (
            <span key={`empty-${index}`} style={{ display: "inline-flex" }}>
              <StarSvg variant="empty" />
            </span>
          ))}
        </div>
      </div>
    );
  };

  const getChoiceButtonSx = (selected) => ({
  position: "relative",
  overflow: "hidden",
  width: "min(520px, 92%)",
  minHeight: 46,
  height: "auto",
  borderRadius: "999px",
  background: "transparent",
  border: "none",
  padding: 0,
  fontFamily: "'Cactus Classical Serif', serif",
  fontWeight: 400,
  fontSize: "14px",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#F2EDE4",
  // Rychlá a plynulá reakce
  transition: "all 0.1s cubic-bezier(0.4, 0, 0.2, 1)",

  // Eliminace MUI interference
  "& .MuiTouchRipple-root": { display: "none" },
  "&:hover": { backgroundColor: "transparent !important", boxShadow: "none" },
  "&:active": { backgroundColor: "transparent !important" },
  "&.Mui-focusVisible": { outline: "none !important", backgroundColor: "transparent !important" },
  WebkitTapHighlightColor: "transparent !important",

  // 3D POSUN (zkrácen na 2px) a ZÁŘE (zmenšena o 50 %)
  transform: selected ? "translateY(2px) !important" : "translateY(0) !important",
  boxShadow: selected
    ? "0 0px 0px 0px #000, 0 0 15px 5px rgba(242, 237, 228, 0.5), inset 0 2px 8px rgba(0,0,0,0.8) !important"
    : "0 2px 0px 0px #000, 0 5px 12px rgba(0,0,0,0.5) !important",

  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "999px",
    background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255,255,255,0) 100%), #1F1F1F",
    border: "0.5px solid #1B1B1B",
    // Vnitřní stín pro hloubku
    boxShadow: selected ? "inset 0 2px 8px rgba(0,0,0,0.8)" : "none",
    opacity: selected ? 1 : 0.7,
    pointerEvents: "none",
    zIndex: 0,
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: "1px",
    borderRadius: "999px",
    background: "linear-gradient(180deg, rgba(242,237,228,0.02) 1.44%, rgba(255,255,255,0) 100%), #1F1F1F",
    // Svítící okraj při vybrání
    border: selected
      ? "1.5px solid rgba(242, 237, 228, 1) !important"
      : "1px solid rgba(242, 237, 228, 0.15) !important",
    pointerEvents: "none",
    zIndex: 0,
  },
});

  
  
  
const toggleChoice = (choice) => {
  // ✅ SINGLE CHOICE: nikdy nesmí být vybrané 2 možnosti zároveň
  if (isSingleChoice) {
    setSelectedAnswers((prev) => (prev[0] === choice ? [] : [choice]));
    return;
  }

  // ✅ MULTI CHOICE (původní chování)
  setSelectedAnswers((prev) =>
    prev.includes(choice) ? prev.filter((c) => c !== choice) : [...prev, choice]
  );
};


  const useHint = async () => {
    if (hintStep < 3) {
      const newRating = Math.max(rating - 0.5, 0);
      const newHintStep = hintStep + 1; // Zvýšíme počet použitých nápověd
  
      setRating(newRating);
      setHintStep(newHintStep);
      const codeToUse = activeGameCode || gameCode;
  
      console.log("?? Odesílám požadavek na aktualizaci ratingu...");
      await fetch(`${backendUrl}/update-rating`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
body: JSON.stringify({ code: codeToUse ? codeToUse.toUpperCase() : codeToUse, rating: newRating })      });
  
      console.log("?? Odesílám požadavek na aktualizaci počtu nápověd...");
      await fetch(`${backendUrl}/update-hints`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
body: JSON.stringify({ code: codeToUse ? codeToUse.toUpperCase() : codeToUse, usedHints: newHintStep })      });
    }
  };



  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    setUploading(true); // ?? Začátek uploadu
  
    const formData = new FormData();
    formData.append("avatar", file);
    formData.append("userId", userId);
  
    try {
      const response = await fetch(`${backendUrl}/upload-avatar`, {
        method: "POST",
        body: formData,
      });
  
      const data = await response.json();
      if (data.success) {
        setAvatarUrl(data.avatarUrl);
        setShowUploadDialog(false); // ? Zavře dialog
      } else {
        console.error("Chyba při nahrávání avataru:", data);
      }
    } catch (error) {
      console.error("Chyba při nahrávání:", error);
    } finally {
      setUploading(false); // ?? Konec uploadu
    }
  };
  

//Logika Audio playeru s hlasovými segmenty

  const VOICE_MARKER_REGEX = /(\[\[VOICE_[A-Z0-9_]+\]\])/g;

const extractVoiceIdFromMarker = (value) => {
  const match = value.match(/\[\[([A-Z0-9_]+)\]\]/);
  return match ? match[1] : null;
};

const getVoiceSegmentById = (voiceId) => {
  if (!Array.isArray(voiceSegments)) return null;
  return voiceSegments.find((segment) => segment?.id === voiceId) || null;
};

const renderVoiceButton = (segment) => {
  const isActive = activeVoiceId === segment.id && isVoicePlaying;

  return (
    <Box
      key={`voice-btn-${segment.id}`}
      sx={{ display: "flex", justifyContent: "center", mb: 0.35, mt: 0.5 }}
    >
      <Button
        onClick={() => toggleVoicePlayback(segment)}
        disableRipple
        disableElevation
        sx={{
          minHeight: 40,
          borderRadius: "999px",
          px: 2,
          color: "#F2EDE4",
          textTransform: "none",
          fontFamily: "'Cactus Classical Serif', serif",
          fontSize: "14px",
          border: "1px solid rgba(242,237,228,0.14)",
          background: "linear-gradient(180deg, rgba(242,237,228,0.06) 0%, rgba(0,0,0,0) 100%)",
          "&:hover": {
            background: "linear-gradient(180deg, rgba(242,237,228,0.10) 0%, rgba(0,0,0,0) 100%)",
          },
        }}
      >
        {isActive ? (
          <PauseIcon sx={{ mr: 0.8, fontSize: 20 }} />
        ) : (
          <PlayArrowIcon sx={{ mr: 0.8, fontSize: 20 }} />
        )}
        {isActive
          ? `Pozastavit hlas${segment.speaker ? `: ${segment.speaker}` : ""}`
          : `Přehrát hlas${segment.speaker ? `: ${segment.speaker}` : ""}`}
      </Button>
    </Box>
  );
};

const renderTextWithVoiceMarkers = (htmlText) => {
  if (!htmlText) return null;

  const sanitized = sanitizeHtml(htmlText);
  const parts = sanitized.split(VOICE_MARKER_REGEX).filter(Boolean);

  return parts.map((part, index) => {
    const voiceId = extractVoiceIdFromMarker(part);

    if (voiceId) {
      const segment = getVoiceSegmentById(voiceId);

      if (!segment?.url) {
        console.warn(`Voice marker ${voiceId} nemá odpovídající voice segment.`);
        return null;
      }

      return renderVoiceButton(segment);
    }

    return (
      <Typography
        key={`voice-text-${index}`}
        variant="body1"
        sx={{
          whiteSpace: "pre-line",
          mb: 2,
          fontFamily: "'Cactus Classical Serif', serif",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "23px",
          textAlign: "center",
          color: "#FFFFFF",
          "& *": {
            fontFamily: "inherit !important",
            fontSize: "inherit !important",
            fontWeight: "inherit !important",
            color: "inherit !important",
            margin: 0,
            lineHeight: "inherit",
          },
        }}
        dangerouslySetInnerHTML={{ __html: part }}
      />
    );
  });
};
  

 // const useHint = () => {
   // setRating(prevRating => Math.max(prevRating - 0.5, 0)); // Snížíme, ale ne pod 0
  //};

  const ResetPasswordBox = ({ token, onClose }) => {
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  
    const handleReset = async () => {
      try {
        const response = await fetch(`${backendUrl}/reset-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, newPassword }),
        });
  
        const data = await response.json();
        if (response.ok) {
          setMessage("? Heslo bylo úspěšně změněno.");
        } else {
          setMessage("? " + data.message);
        }
      } catch (err) {
        setMessage("? Chyba při komunikaci se serverem.");
      }
    };
  
    return (
      <Box
        sx={{
          position: "relative",
          background: "transparent",
          borderRadius: "20px",
          padding: "1px",
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
            border: "0.5px solid #2F353E",
            borderRadius: "20px",
            padding: 3,
            color: "#F2EDE4",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" sx={landingTitleSx}>Obnovení hesla</Typography>
          <input
            type="password"
            placeholder="NovÆc heslo"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            onFocus={() => setIsPasswordFocused(true)}
            onBlur={() => setIsPasswordFocused(false)}
            style={{
              padding: "12px 14px",
              width: "100%",
              marginBottom: "10px",
              backgroundColor: "#0F1114",
              border: isPasswordFocused
                ? "0.5px solid #F2EDE4"
                : "0.5px solid rgba(242, 237, 228, 0.2)",
              borderRadius: "10px",
              color: "#F2EDE4",
              fontFamily: "'Cactus Classical Serif', serif",
              fontSize: "14px",
              outline: "none",
              boxSizing: "border-box",
            }}
          />
          <Button variant="contained" onClick={handleReset} sx={{ ...landingButtonSx, mt: 2 }}>Změnit heslo</Button>
          {message && (
            <Typography sx={{ mt: 2, color: message.startsWith("?") ? "lightgreen" : "red", fontFamily: "'Cactus Classical Serif', serif" }}>
              {message}
            </Typography>
          )}
          <Button onClick={onClose} sx={{ ...landingButtonSx, mt: 2 }}>Zpět</Button>
        </Box>
      </Box>
    );
  };
  
  const closeAllOverlays = () => {
    setIsRulesOpen(false);
    setIsLeaderboardOpen(false);
    setIsAccountOpen(false);
    setIsResettingPassword(false);
    setIsRequestingReset(false);
    setIsRegistering(false);
  };

  const handleOpenRules = () => {
    closeAllOverlays();
    setIsRulesOpen(true);
  };

  const handleOpenLeaderboard = () => {
    closeAllOverlays();
    setIsLeaderboardOpen(true);
  };

  const handleOpenAccount = () => {
    closeAllOverlays();
    setIsAccountOpen(true);
  };

  const renderLogo = () => (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 1 }}>
      <Box
        component="img"
        src={logo}
        alt="Logo Eshop Game"
        sx={{
          width: "100%",
          maxWidth: { xs: "80%", sm: "400px" },
          height: "auto",
        }}
      />
    </Box>
  );

const gamePaperSx = {
  backgroundColor: "var(--game-surface-color, #111)",
  backgroundImage: "var(--game-panel-texture, none)",
    color: "var(--game-text-color, #ddd)",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    minHeight: { xs: "100dvh", sm: "auto" },
    p: { xs: 0, sm: 3 },
    border: { xs: "none", sm: "1px solid rgba(255, 255, 255, 0.2)" },
    boxShadow: { xs: "none", sm: "0 0 15px rgba(255, 255, 255, 0.1)" },
    borderRadius: { xs: 0, sm: "10px" },
    mt: { xs: 0, sm: 2 },
    mb: { xs: 0, sm: 2 },
    mx: { xs: 0, sm: "auto" },
    width: { xs: "100%", sm: "auto" },
    maxWidth: { xs: "100%", sm: "auto" },
  boxSizing: "border-box",
};

  const completedCount = completedGameList.length;
  const totalSeconds = completedGameList.reduce((sum, game) => sum + Number(game.elapsed_time || 0), 0);
  const totalHours = isNaN(totalSeconds) ? 0 : Math.round(totalSeconds / 3600);
  const sumRating = completedGameList.reduce((sum, game) => sum + Number(game.rating || 0), 0);
  const avgRating = completedCount ? sumRating / completedCount : 0;
  const successPct = isNaN(avgRating) ? 0 : Math.round((avgRating / 10) * 100);
  const totalHoursDisplay = Number.isFinite(totalHours) ? `${totalHours}h` : "0h";
  const successPctDisplay = Number.isFinite(successPct) ? `${successPct}%` : "0%";
  const activeView = (() => {
    if (isRulesOpen) return "rules";
    if (isLeaderboardOpen) return "leaderboard";
    if (isAccountOpen) return "account";
    if (isResettingPassword) return "reset-password";
    if (isRequestingReset) return "request-reset";
    if (isRegistering && !isLoggedIn) return "register";
    if (showReviewForm && !window.reviewSubmitted) return "review";
    if (isInGame) return "game";
    return "dashboard";
  })();

  const activeGameTextureUrl =
    gameUiConfig.screenTextureUrl ||
    gameUiConfig.backgroundTextureUrl ||
    bitwiseGlitch;
  const activeGameTextureOpacity = gameUiConfig.textureOpacity ?? 0.3;

  useEffect(() => {
    if (activeView !== "game") return undefined;

    const resetScrollToTop = () => {
      const scrollingElement = document.scrollingElement || document.documentElement;
      if (scrollingElement) {
        scrollingElement.scrollTop = 0;
      }
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    };

    let raf1 = 0;
    let raf2 = 0;
    const timeoutId = window.setTimeout(resetScrollToTop, 80);

    resetScrollToTop();
    raf1 = window.requestAnimationFrame(() => {
      resetScrollToTop();
      raf2 = window.requestAnimationFrame(resetScrollToTop);
    });

    return () => {
      window.clearTimeout(timeoutId);
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [activeView, isNewGame, isStoryScreen, currentQuestion, isGameCompleted]);

  const finalTitle = introGameTitle || NazevHry || "";

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        width: "100%",
        maxWidth: "100vw",
        backgroundColor: "#0F1114",
        position: "relative",
        overflowX: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${activeView === "game" ? activeGameTextureUrl : bitwiseGlitch})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          mixBlendMode: "soft-light",
          opacity: 0.15,
          pointerEvents: "none",
          zIndex: 0,
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Navbar
          onLogout={logout}
          isLoggedIn={isLoggedIn}
          onOpenRules={handleOpenRules}
          onOpenLeaderboard={handleOpenLeaderboard}
          onOpenAccount={handleOpenAccount}
          isInGame={isInGame}
        />
{/* ? Dialog pro neplatný kód */}
<Dialog
  open={showInvalidCodeDialog}
  onClose={() => setShowInvalidCodeDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Neplatný kód hry
  </DialogTitle>

  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Zadaný kód neexistuje. Zkontrolujte správnost a zkuste to znovu.
    </Typography>
  </DialogContent>

  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowInvalidCodeDialog(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro nutný login */}
{/* ? Dialog pro nutný login */}
<Dialog
  open={showLoginRequiredDialog}
  onClose={() => setShowLoginRequiredDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}
  >
    Přihlaste se
  </DialogTitle>

  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd", mt:4 }}>
      Pro spuštění hry se nejprve přihlaste nebo si vytvořte účet.
    </Typography>
  </DialogContent>

  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowLoginRequiredDialog(false)}
      sx={{
        backgroundColor: "#444",
        color: "#fff",
        "&:hover": { backgroundColor: "#666" },
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>


{/* ? Dialog pro úspěšné přihlášení */}
<Dialog
  open={showLoginSuccessDialog}
  onClose={() => setShowLoginSuccessDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  {/* ? Dialog pro prihlaseni */}
  <DialogTitle sx={dialogTitleSx}>
    Přihlášení úspěšné
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Byl jste úspěšně přihlášen.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowLoginSuccessDialog(false)}
      sx={{ backgroundColor: "#007bff", color: "#fff", "&:hover": { backgroundColor: "#0056b3" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro zmenu hesla */}

<Dialog
  open={showDialog}
  onClose={() => setShowDialog(false)}
  sx={{
    "& .MuiDialog-paper": {
      backgroundColor: "#222",  // ? Tmavé pozadí
      color: "#fff",  // ? Bílý text
      borderRadius: "10px",
      padding: "20px",
      border: "1px solid rgba(255, 255, 255, 0.2)", // ? Ohraničení jako zbytek aplikace
      boxShadow: "0 0 15px rgba(255, 255, 255, 0.1)", // ? Jemný světelný efekt
    },
  }}
>
  <DialogTitle sx={dialogTitleSx}
  >
    Změna hesla
  </DialogTitle>

  <DialogContent>
    <Typography 
      variant="body1"
      sx={{ color: "#ddd", textAlign: "center", fontSize: "1.1rem", marginTop: "10px" }}
    >
      {dialogMessage}
    </Typography>
  </DialogContent>

  <DialogActions sx={dialogActionsSx}> {/* ? Tlačítko zarovnáno doprostřed */}
    <Button 
      onClick={() => setShowDialog(false)} 
      sx={{   
        backgroundColor: "#222",
        color: "#fff",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        padding: "8px 20px",
        fontWeight: "bold",
        transition: "all 0.3s ease",
        "&:hover": { backgroundColor: "#444", boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)" },
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>



{/* ? Dialog pro odpovědi */}
<Dialog
  open={showAnswerDialog}
  onClose={() => setShowAnswerDialog(false)}
  PaperProps={{
    sx: isGameAnswerFeedbackDialog
      ? gameFeedbackDialogPaperSx
      : dialogPaperSx,
  }}
>
  <DialogTitle sx={
    isGameAnswerFeedbackDialog
      ? gameFeedbackDialogTitleSx
      : dialogTitleSx
  }>
    {answerDialogTitle}
  </DialogTitle>
  {!isGameAnswerFeedbackDialog && (
    <DialogContent>
      <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
        {answerDialogMessage}
      </Typography>
    </DialogContent>
  )}
  <DialogActions sx={
    isGameAnswerFeedbackDialog
      ? gameFeedbackDialogActionsSx
      : dialogActionsSx
  }>
    <Button
      variant="contained"
      onClick={() => setShowAnswerDialog(false)}
      sx={
        isGameAnswerFeedbackDialog
          ? gameFeedbackButtonSx
          : { backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }
      }
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro odhlášení */}
<Dialog
  open={showLogoutDialog}
  onClose={() => setShowLogoutDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Odhlášení
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Byl jste úspěšně odhlášen.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowLogoutDialog(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>


 {/* ? NOVÝ KÓD - Dialogové okno pro potvrzení odchodu */}
 <Dialog
        open={showExitDialog}
        onClose={() => setShowExitDialog(false)}
        PaperProps={{ sx: dialogPaperSx }}
      >
        <DialogTitle sx={dialogTitleSx}>
          Opravdu chcete opustit aplikaci?
        </DialogTitle>

      

        <DialogActions sx={dialogActionsSx}>
          <Button
            variant="contained"
            onClick={() => setShowExitDialog(false)}
            sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
          >
            Zůstat
          </Button>
          <Button
            variant="contained"
            onClick={() => window.history.back()}
            sx={{ backgroundColor: "#c00", color: "#fff", "&:hover": { backgroundColor: "#e00" } }}
          >
            Opustit
          </Button>
        </DialogActions>
      </Dialog>

      {/* ? Dialogové okno - Úspěšné propojení hry s účtem */}
<Dialog
  open={showGameConnectedDialog}
  onClose={() => setShowGameConnectedDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Hra úspěšně propojena!
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Vaše hra byla úspěšně propojena s vaším účtem.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowGameConnectedDialog(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro chybu při přihlášení / registraci */}
<Dialog
  open={showLoginErrorDialog}
  onClose={() => setShowLoginErrorDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Chyba
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      {loginErrorMessage}
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowLoginErrorDialog(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro vypršení času */}

<Dialog
  open={timeExpiredDialogOpen}
  onClose={() => {}} // záměrně bez zavírání kliknutím mimo
  PaperProps={{ sx: gameFeedbackDialogPaperSx }}

>
  <DialogTitle sx={gameFeedbackDialogTitleSx}>Čas vypršel</DialogTitle>

  <DialogActions sx={gameFeedbackDialogActionsSx}>
    <Button onClick={handleTimeoutContinue} variant="contained" sx={gameFeedbackButtonSx}>
      Pokračovat
    </Button>
  </DialogActions>
</Dialog>

{/* ? Dialog pro upload avatar */}
<Dialog
  open={showUploadDialog}
  onClose={() => setShowUploadDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}
  >
    Nahrát nový obrázek
  </DialogTitle>

  <DialogContent>
    <Typography 
      variant="body1"
      sx={{ color: "#ddd", textAlign: "center", fontSize: "1.1rem", marginTop: "10px" }}
    >
      Vyberte soubor a nahrajte nový obrázek jako vašeho avatara.
    </Typography>

    <input 
      type="file"
      accept="image/*"
      onChange={handleFileUpload}
      style={{
        display: "block",
        margin: "15px auto",
        padding: "10px",
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "5px",
        cursor: "pointer",
        border: "1px solid rgba(255, 255, 255, 0.3)"
      }}
    />
    {uploading && (
    <Typography variant="body2" sx={{ color: "#aaa", textAlign: "center", mt: 2 }}>
      Nahrávám obrázek...
    </Typography>
  )}
  </DialogContent>

  <DialogActions sx={dialogActionsSx}>
    <Button 
      onClick={() => setShowUploadDialog(false)} 
      sx={{   
        backgroundColor: "#222",
        color: "#fff",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        padding: "8px 20px",
        fontWeight: "bold",
        transition: "all 0.3s ease",
        "&:hover": { backgroundColor: "#444", boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)" },
      }}
    >
      Zpět
    </Button>
  </DialogActions>
</Dialog>


{/* ? Dialog pro neplatný e-mail */}
<Dialog
  open={showEmailErrorDialog}
  onClose={() => setShowEmailErrorDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Neplatný e-mail
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Zadejte platnou e-mailovou adresu (např. uzivatel@domena.cz).
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowEmailErrorDialog(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>


{/* ? Dialog pro úspěšnou registraci */}
<Dialog
  open={showRegisterSuccessDialog}
  onClose={() => setShowRegisterSuccessDialog(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Registrace úspěšná
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Registrace proběhla úspěšně! Přihlaste se prosím.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setShowRegisterSuccessDialog(false)}
      sx={{ backgroundColor: "#007bff", color: "#fff", "&:hover": { backgroundColor: "#0056b3" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>




    <ContentWrapper isInGame={isInGame}>
{!isLoggedIn && (activeView === "dashboard" || activeView === "register" || activeView === "reset-password" || activeView === "request-reset") && renderLogo()}

{activeView === "reset-password" && (
  <Box
    sx={{
      position: "relative",
      background: "transparent",
      borderRadius: "20px",
      padding: "1px",
      mt: overlayTopMargin,
    }}
  >
  <Box
    sx={{
      background: "transparent",
      border: "none",
      borderRadius: "20px",
      boxShadow: "none",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
    }}
  >
      <Typography variant="h6" sx={landingTitleSx}>Nastavení nového hesla</Typography>
      <Box sx={landingDividerSx} />

      <TextField
        label="Nové heslo"
        type="password"
        fullWidth
        variant="outlined"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        sx={{ ...landingTextFieldSx, mt: 2 }}
      />

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <Button variant="contained" onClick={handleResetPassword} sx={landingButtonSx}>
          Změnit heslo
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            closeAllOverlays();
            setResetToken("");
            window.history.replaceState(null, "", window.location.pathname);
          }}
          sx={landingButtonSx}
        >
          Zpět
        </Button>
      </Box>
    </Box>
  </Box>
)}

{activeView === "request-reset" && (
  <Box
    sx={{
      position: "relative",
      background: "transparent",
      borderRadius: "20px",
      padding: "1px",
      mt: overlayTopMargin,
    }}
  >
    <Box
      sx={{
        background: "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
        border: "0.5px solid #2F353E",
        borderRadius: "20px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" sx={landingTitleSx}>Obnovení hesla</Typography>
      <Box sx={landingDividerSx} />

      <TextField
        label="Zadejte svůj email"
        fullWidth
        variant="outlined"
        value={resetEmail}
        onChange={(e) => setResetEmail(e.target.value)}
        sx={{ ...landingTextFieldSx, mt: 2 }}
      />

     <Button variant="contained" onClick={closeAllOverlays} sx={landingButtonSx}>
          Zpět
        </Button>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <Button variant="contained" onClick={handleRequestReset} sx={landingButtonSx}>
          Odeslat žádost
        </Button>

      </Box>
    </Box>
  </Box>
)}

{activeView === "review" && <ReviewForm />}

{/* ? P‘tidanÆñ box pro pravidla ƒ?" zobrazÆð se navÆðc nad obsahem */}
{activeView === "rules" && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: 1,
      width: "100%",
      height: "100dvh",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      mt: 0,
      pt: 0,
      background: "transparent",
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: "600px",
        px: { xs: 0, sm: 2 },
        pt: 0,
        display: "flex",
        flexDirection: "column",
        background: "transparent",
        boxShadow: "none",
        border: "none",
        position: "relative",
      }}
    >
      <Rules onClose={closeAllOverlays} />
    </Box>
  </Box>
)}

{/* 🏆 Box pro Leaderboard – zobrazí se, když je otevřený */}
{activeView === "leaderboard" && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: 1,
      width: "100%",
      height: "100dvh",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      mt: 0,            // ✅ zrušit
      pt: 0,            // ✅ zrušit
      background: "transparent",
           overflowY: "auto",
    overflowX: "hidden",
     WebkitOverflowScrolling: "touch",
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: "600px",
        padding: "0 20px",
        paddingTop: 0,      // ✅ přidat
        display: "flex",
        flexDirection: "column",
        background: "transparent",
        boxShadow: "none",
        border: "none",

        // ✅ důležité: hero se ořízne uvnitř tohohle boxu
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* ✅ HERO (background) – JE V APP.JS, takže nadpis Žebříček nezmizí */}
      {!!leaderboardHeroUrl && (
<Box
  sx={{
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,

   width: "100%",
    aspectRatio: "4 / 4",   // ✅ tady je celá změna


    overflow: "hidden",
    zIndex: 0,
  }}
>

          {/* „Smrsknout do ratia“ (contain), a pak lehce přiblížit + oříznout wrapperem */}
<Box
  component="img"
  src={leaderboardHeroUrl}
  alt=""
  sx={{
    width: "100%",
    height: "100%",
    objectFit: "cover",        // ✅ bez pruhů
    objectPosition: "center",  // můžeme doladit per hra
        // ✅ skutečný fade do průhlednosti
    WebkitMaskImage:
      "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 65%, rgba(0,0,0,0) 100%)",
    maskImage:
      "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 65%, rgba(0,0,0,0) 100%)",

    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
  }}
/>


          {/* horní jemné ztmavení */}
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: "35%",
              background: "linear-gradient(to bottom, rgba(14,14,14,0.92) 0%, rgba(14,14,14,0) 100%)",
            }}
          />

        </Box>
      )}

      {/* ✅ Nadpis + divider musí být NAD hero */}
      <Box sx={{ position: "relative", zIndex: 2,pt: { xs: 2.5, sm: 3.5 } }}>
        <Box
  sx={{
    position: "absolute",
    left: 6,
    top: 10,
    zIndex: 5,
    display: "flex",
    alignItems: "center",
  }}
>
<IconButton
  onClick={() => {
    setLeaderboardHeroUrl(null);
    closeAllOverlays();
  }}
  disableRipple
  sx={{
    position: "fixed",

    // ✅ ZRCADLO hamburgeru z Navbar.js
    top: 12,
    left: { xs: 12, md: "max(12px, calc(50% - 320px))" },

    zIndex: 2001, // o chlup víc než hamburger = vždy nad hero
    color: "#F2EDE4",   // ✅ tvoje UI bílá

    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    "&:hover": { backgroundColor: "transparent" },
  }}
>
  <WestIcon sx={{ fontSize: 32 }} />
</IconButton>



</Box>

        <Typography variant="h6" sx={landingTitleSx}>
          Leaderboard
        </Typography>
        <Box sx={{ ...landingDividerSx, opacity: 0.5 }} />
      </Box>

      {/* ✅ Leaderboard content NAD hero */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        <Leaderboard
          onClose={closeAllOverlays}
          hasHero={!!leaderboardHeroUrl}
          onHeroChange={(url) => setLeaderboardHeroUrl(url)}
        />
      </Box>

    </Box>
  </Box>
)}


{/* ? Box pro "Muj Ucet */}
{activeView === "account" && (() => {
  // --- STYLY jen pro Account box (lokální, aby se nic jinde nerozbilo) ---
  const accountOuterSx = {
    position: "relative",
    background: "transparent",
    borderRadius: "28px",
    padding: "1px",
    mt: { xs: 7, sm: 4 },
  };

  const accountCardSx = {
    position: "relative",
    overflow: "hidden",
    borderRadius: "28px",
    padding: { xs: "22px 18px 18px", sm: "26px 22px 20px" },
    width: "100%",
    background:
      "radial-gradient(120% 90% at 50% 8%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 55%), " +
      "linear-gradient(180deg, rgba(15,17,20,0.0) 0%, rgba(15,17,20,0.45) 72%), #121418",
    border: "1px solid rgba(242,237,228,0.10)",
    boxShadow:
      "0 18px 60px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.06)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const topGlowSx = {
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    background:
      "radial-gradient(80% 55% at 50% 0%, rgba(242,237,228,0.10) 0%, rgba(242,237,228,0.0) 55%)",
    opacity: 0.8,
  };

  const avatarWrapSx = {
    position: "relative",
    width: 150,
    height: 150,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    mb: 2.5,
  };

  const avatarRingSx = {
    position: "absolute",
    inset: -3,
    borderRadius: "50%",
    border: "2px solid rgba(242,237,228,0.75)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.55)",
  };

  const avatarSx = {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    backgroundImage: `url(${avatarUrl || "/default-avatar.png"})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    filter: "contrast(1.05) saturate(1.02)",
  };

const cameraBtnSx = {
  position: "absolute",
  right: -12,   // ✅ bylo 6 → negativní = víc mimo avatar
  bottom: -12,  // ✅ bylo 6
  width: 56,    // ✅ bylo 52 → větší bublina
  height: 56,
  borderRadius: "999px",
  background: "rgba(242,237,228,0.95)",
  border: "1px solid rgba(0,0,0,0.18)",
  boxShadow: "0 10px 26px rgba(0,0,0,0.45)",
  display: "flex",          // ✅ jistota perfektního centrování
  alignItems: "center",
  justifyContent: "center",
  "&:hover": { background: "rgba(242,237,228,0.98)" },
};

  const rowsWrapSx = {
    width: "100%",
    mt: 0.5,
  };

  const rowSx = {
    display: "grid",
    gridTemplateColumns: "44px 1fr auto",
    alignItems: "center",
    columnGap: "12px",
    py: 1.6,
  };

  const leftIconSx = {
    width: 38,
    height: 38,
    borderRadius: "999px",
    display: "grid",
    placeItems: "center",
    color: "rgba(242,237,228,0.95)",
    border: "1px solid rgba(242,237,228,0.20)",
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(0,0,0,0.12) 100%)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06)",
  };

  const labelSx = {
    fontFamily: "'Cactus Classical Serif', serif",
    color: "rgba(242,237,228,0.45)",
    textTransform: "uppercase",
    fontSize: "12px",
    letterSpacing: "0.12em",
    lineHeight: 1.1,
  };

  const valueSx = {
    fontFamily: "'Cactus Classical Serif', serif",
    color: "#F2EDE4",
    fontSize: { xs: "20px", sm: "22px" },
    letterSpacing: "0.04em",
    lineHeight: 1.15,
    mt: 0.35,
  };

  const dividerSx = {
    height: "1px",
    width: "100%",
    background:
      "linear-gradient(90deg, rgba(242,237,228,0.0) 0%, rgba(242,237,228,0.12) 20%, rgba(242,237,228,0.12) 80%, rgba(242,237,228,0.0) 100%)",
  };

  const primaryBtnSx = {
    width: "100%",
    minHeight: 54,
    borderRadius: "18px",
    mt: 2.2,
    fontFamily: "'Cactus Classical Serif', serif",
    textTransform: "uppercase",
    letterSpacing: "0.14em",
    fontSize: "15px",
    color: "#F2EDE4",
    background:
      "linear-gradient(180deg, rgba(242,237,228,0.10) 0%, rgba(242,237,228,0.05) 100%), rgba(120, 140, 170, 0.35)",
    border: "1px solid rgba(242,237,228,0.12)",
    boxShadow: "0 14px 40px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.06)",
    "&:hover": {
      background:
        "linear-gradient(180deg, rgba(242,237,228,0.12) 0%, rgba(242,237,228,0.06) 100%), rgba(120, 140, 170, 0.42)",
    },
  };

  const secondaryBtnSx = {
    ...primaryBtnSx,
    mt: 1.6,
    background:
      "linear-gradient(180deg, rgba(242,237,228,0.06) 0%, rgba(242,237,228,0.03) 100%), rgba(120, 140, 170, 0.22)",
  };

  const editIconBtnSx = {
    color: "rgba(242,237,228,0.85)",
    border: "1px solid rgba(242,237,228,0.18)",
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(0,0,0,0.10) 100%)",
    width: 36,
    height: 36,
    borderRadius: "10px",
    "&:hover": {
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(0,0,0,0.14) 100%)",
    },
  };

  return (
<Box
  sx={{
    ...accountOuterSx,
    width: "100%",
    display: "flex",
    justifyContent: "center",
  }}
>
<Box
  sx={{
    ...accountCardSx,
    width: "100%",
    maxWidth: 520,
    px: { xs: 2, sm: 0 },   // ✅ symetrické okraje na mobilu
    boxSizing: "border-box",
        transform: { xs: "translateX(-2px)", sm: "none" },
  }}
>
        {/* jemný glow nahoře */}
        <Box sx={topGlowSx} />

        {/* Nadpis */}
        <Typography
          sx={{
            fontFamily: "'Cinzel', serif",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            fontSize: "16px",
            color: "#F2EDE4",
            mb: 1,
          }}
        >
          MŮJ ÚČET
        </Typography>

        <Box sx={{ ...dividerSx, mb: 2.2 }} />

        {/* Avatar + kamera */}
        <Box sx={avatarWrapSx}>
          <Box sx={avatarRingSx} />
          <Box
            sx={avatarSx}
            onClick={() => setShowUploadDialog(true)}
            title="Změnit avatar"
          />
          <IconButton
            sx={cameraBtnSx}
            onClick={() => setShowUploadDialog(true)}
            aria-label="Změnit avatar"
          >
            <PhotoCameraOutlinedIcon sx={{ color: "#121418",
    fontSize: 30,   // ✅ větší ikonka
    ml: "1px",      // ✅ mikro optické centrování (některé ikony jsou “těžší” vlevo)
    mt: "1px", }} />
          </IconButton>
        </Box>

        {/* Řádky */}
        <Box sx={rowsWrapSx}>
          {/* USERNAME */}
          <Box sx={rowSx}>
            <Box sx={leftIconSx}>
              <PersonOutlineIcon />
            </Box>
            <Box>
              <Typography sx={valueSx}>{username}</Typography>
              <Typography sx={labelSx}>NÁZEV TÝMU</Typography>
            </Box>
            <Box />
          </Box>
          <Box sx={dividerSx} />

          {/* EMAIL */}
          <Box sx={rowSx}>
            <Box sx={leftIconSx}>
              <AlternateEmailIcon />
            </Box>
            <Box>
              <Typography sx={valueSx}>{email}</Typography>
              <Typography sx={labelSx}>EMAIL</Typography>
            </Box>
            <Box />
          </Box>
          <Box sx={dividerSx} />

          {/* PASSWORD */}
          <Box sx={rowSx}>
            <Box sx={leftIconSx}>
              <LockOutlinedIcon />
            </Box>
            <Box>
              <Typography sx={valueSx}>********</Typography>
              <Typography sx={labelSx}>HESLO</Typography>
            </Box>

            {/* “tužka” jako v referenci – otevře změnu hesla */}
            <IconButton
              sx={editIconBtnSx}
              onClick={() => setIsChangingPassword(true)}
              aria-label="Změnit heslo"
            >
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Změna hesla – vysune se pod řádky */}
          {isChangingPassword && (
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Stávající heslo"
                type="password"
                fullWidth
                variant="outlined"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                sx={{ ...landingTextFieldSx, mt: 0 }}
              />
              <TextField
                label="Nové heslo"
                type="password"
                fullWidth
                variant="outlined"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                sx={{ ...landingTextFieldSx, mt: 2 }}
              />
            </Box>
          )}
        </Box>

        {/* CTA tlačítka dole */}
{isChangingPassword && (
  <Button
    variant="contained"
    onClick={handleChangePassword}
    sx={primaryBtnSx}
  >
    ULOŽIT
  </Button>
)}

     <Button
  onClick={() => {
    if (isChangingPassword) {
      setIsChangingPassword(false);
      setCurrentPassword("");
      setNewPassword("");
      // (volitelně) když máš error message pro změnu hesla, tak ji tu taky resetni
      // setPasswordError("");
    } else {
      closeAllOverlays();
    }
  }}
  sx={secondaryBtnSx}   // nebo { ...landingButtonSx, mt: 3, mb: 1 } – jak to máš teď
>
  ZPĚT
</Button>

        <Button
          onClick={() => {
            logout();
            closeAllOverlays();
          }}
          sx={{
            fontFamily: "'Cactus Classical Serif', serif",
            color: "#d32f2f",
            fontSize: "12px",
            mt: 1.6,
            textTransform: "uppercase",
            letterSpacing: "0.14em",
          }}
        >
          ODHLÁSIT SE
        </Button>
      </Box>
    </Box>
  );
})()}
{activeView === "dashboard" && (
  isLoggedIn ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 0 }}>
          <Box
            sx={{
              background: "linear-gradient(360deg, rgba(242, 237, 228, 0.06) 0%, rgba(26, 29, 34, 0.3) 66.35%), #171A1F",
              mx: { xs: -2, sm: 0 },
             width: { xs: "calc(100% + 32px)", sm: "100%" },
              px: 0,
              pt: 4,
              pb: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
              borderRadius: { sm: "10px" },
             // 🔥 ZDE JE ZMĚNA:
      // 1. Tvoje původní světlá linka nahoře (inset 0 1px 0)
      // 2. Tmavá linka zevnitř na spodní hraně pro "objem" (inset 0 -1px 0)
      // 3. Měkký stín padající pod box, který ho odlepí od obsahu pod ním (0 12px 24px -8px)
      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -1px 0 rgba(0,0,0,0.5), 0 12px 24px -8px rgba(0,0,0,0.6)",
            }}
          >
            <Box
              sx={{
                width: 130,
                height: 130,
                borderRadius: "50%",
                backgroundImage: `url(${avatarUrl || "/default-avatar.png"})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                border: "2px solid #2F353E",
                cursor: "pointer",
              }}
              onClick={() => setShowUploadDialog(true)}
            />
            <Typography
              variant="body1"
              sx={{
                fontFamily: "'Cactus Classical Serif', serif",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "#F2EDE4",

              fontSize: "22px",
                mt: 1,
                mb: 1,
              }}
            >
              {username}
            </Typography>
          </Box>
<Box sx={{ display: "flex", gap: 1.5, mt: 1, mb: 3 }}>
  {[
    { label: "HRY", value: completedCount },
    { label: "HRANÍ", value: totalHoursDisplay },
    { label: "ÚSPĚŠNOST", value: successPctDisplay },
  ].map((stat) => (
 <Box
      key={stat.label}
      sx={{
        flex: 1,
        position: "relative",
        
        // ✅ OPRAVA: Plynulý gradient bez "zubu" v polovině. 
        // Jde ze světlé (25% viditelnost) nahoře do ztracena dole.
        background: "linear-gradient(180deg, rgba(242, 237, 228, 0.25) 0%, rgba(242, 237, 228, 0.05) 45%, rgba(0, 0, 0, 0) 100%)",
        
        // Zmenšil jsem i stín, aby nepůsobil na menším boxu moc agresivně
       // boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.4)",
        
        borderRadius: "20px",
        padding: "1px",
        display: "flex",
      }}
    >
      <Box
        sx={{
          // TVŮJ PŮVODNÍ KÓD BEZ ZMĚN
          width: "100%",
          height: "100%",
          background: "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
          border: "0.5px solid #2F353E",
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 1.5,

        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: "'Cactus Classical Serif', serif",
            color: "rgba(127, 150, 188, 0.5)",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            mb: 0.5,
            fontSize: "10px",
          }}
        >
          {stat.label}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Cactus Classical Serif', serif",
            color: "#F2EDE4",
            fontSize: "16px",
          }}
        >
          {stat.value}
        </Typography>
      </Box>
    </Box>
  ))}
</Box>

                    {/* --- 3. INPUT SECTION (3D Style) --- */}
<Box sx={{ ...panelSoft3DSx, mt: 1,transform: "translateY(-4px)" }}>
  <Box
    sx={{
      position: "relative",
      zIndex: 1,
      padding: { xs: "18px", sm: "20px" },
      display: "flex",
      flexDirection: "column",
    }}
  >
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "'Cactus Classical Serif', serif",
                  fontSize: "20px",
                  fontWeight: 400,
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  textAlign: "center",
                  color: "#F2EDE4",
                  marginBottom: "24px",
                }}
              >
                Vložit kód hry
              </Typography>
              <Box sx={{ ...landingDividerSx, mb: 2 }} />
              <TextField
                id="gameCodeInput"
                label="Zadejte kód"
                fullWidth
                variant="outlined"
                value={gameCode}
                onChange={(e) => setGameCode(e.target.value.toUpperCase())}
                sx={{ ...landingTextFieldSx, mt: 1 }}
              />
              <Button variant="contained" color="primary" onClick={submitGameCode} sx={{ ...landingButtonSx, mt: 2 }}>
                Odemknout hru
              </Button>
            </Box>
          </Box>

          {/* --- 4. TABS NAVIGATION (Animated Switch) --- */}
          <SwitchAnimace
            activeTab={activeTab}
            onTabChange={setActiveTab}
            tabs={[
              { key: "rozehrane", label: "ROZEHRANÉ" },
              { key: "dokoncene", label: "DOKONČENÉ" },
              { key: "nove", label: "NOVÉ" },
            ]}
          />
<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 1 }}>
            {activeTab === "rozehrane" &&
              (gameList.length > 0 ? (
                gameList.map((game) => (
                  <Box
                    key={game.code}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: "12px 0",
                      borderBottom: "1px solid #2F353E",
                      background:
                        "linear-gradient(90deg, #1A1D22 0%, rgba(26, 29, 34, 0) 100%)",
                    }}
                  >
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "8px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        backgroundImage: game.introscreenimage ? `url(${game.introscreenimage})` : "none",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        flexShrink: 0,
                        ml: 1,
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "'Cactus Classical Serif', serif",
                          color: "#F2EDE4",
                          textTransform: "uppercase",
                        }}
                      >
                        {game.game_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "'Cactus Classical Serif', serif",
                          color: "rgba(127, 150, 188, 0.5)",
                        }}
                      >
                        Pokračovat v rozehrané hře
                      </Typography>
                    </Box>
                    <IconButton onClick={() => handleContinueGame(game)} sx={{ color: "#5D6D7E" }}>
                      <PlayArrowIcon sx={{ fontSize: 50 }} />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "'Cactus Classical Serif', serif",
                    color: "rgba(127, 150, 188, 0.5)",
                    textAlign: "center",
                  }}
                >
                  Žádné rozehrané hry
                </Typography>
              ))}

            {activeTab === "dokoncene" &&
              (completedGameList.length > 0 ? (
                completedGameList.map((game) => (
                  <Box
                    key={game.code}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: "12px 0",
                      borderBottom: "1px solid #2F353E",
                      background:
                        "linear-gradient(90deg, #1A1D22 0%, rgba(26, 29, 34, 0) 100%)",
                    }}
                  >
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "8px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        backgroundImage: game.introscreenimage ? `url(${game.introscreenimage})` : "none",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        flexShrink: 0,
                         ml: 1,
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "'Cactus Classical Serif', serif",
                          color: "#F2EDE4",
                          textTransform: "uppercase",
                        }}
                      >
                        {game.game_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontFamily: "'Cactus Classical Serif', serif",
                          color: "rgba(127, 150, 188, 0.5)",
                        }}
                      >
                        Hodnocení: {game.rating !== null ? `${game.rating} ${ICON_STAR}` : "N/A"}
                      </Typography>
                    </Box>
                    <Tooltip title="Zobrazit statistiky">
                      <IconButton
                        onClick={() => handleContinueGame(game)}
                        aria-label={`Zobrazit statistiky hry ${game.game_name}`}
                        sx={{ color: "#5D6D7E" }}
                      >
                        <AssessmentOutlinedIcon sx={{ fontSize: 46 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                ))
              ) : (
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "'Cactus Classical Serif', serif",
                    color: "rgba(127, 150, 188, 0.5)",
                    textAlign: "center",
                  }}
                >
                  Žádné dokončené hry
                </Typography>
              ))}

            {activeTab === "nove" && (
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "'Cactus Classical Serif', serif",
                  color: "rgba(127, 150, 188, 0.5)",
                  textAlign: "center",
                }}
              >
                Žádné nové hry
              </Typography>
            )}
          </Box>
        </Box>
      ) : (
        <div>
          <Box
            sx={{
              position: "relative",
      background: "transparent",
      borderRadius: "20px",
      padding: "1px",
      mt: { xs: 7, sm: 4 },
    }}
  >
            <Box
              sx={{
                background: "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
                border: "0.5px solid #2F353E",
                borderRadius: "20px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
              }}
            >
            <Typography variant="h6" sx={landingTitleSx}>Přihlášení</Typography>
            <Box sx={landingDividerSx} />
            <TextField
               id="loginEmail" // Přidání id pro email
              label="Email nebo název týmu"
              value={loginIdentifier}
              onChange={(e) => setLoginIdentifier(e.target.value)}
              fullWidth
              variant="outlined"
              sx={{ ...landingTextFieldSx, mt: 2 }}
            />
            <TextField
              id="loginPass" // Přidání id pro heslo
              label="Heslo"
              value={loginPasswordInput}
              onChange={(e) => setLoginPasswordInput(e.target.value)}
              type="password"
              fullWidth
              variant="outlined"
              sx={{ ...landingTextFieldSx, mt: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => login(loginIdentifier, loginPasswordInput)}
              sx={{ ...landingButtonSx, mt: 2 }}
            >
              Přihlásit
            </Button>
                 {/* Text pro přepnutí na registrační formulář */}
          <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Nemáte ještě účet?{" "}
            <Button
              onClick={() => {
                closeAllOverlays();
                setIsRegistering(true);
              }}
              sx={{ color: "#7F96BC", textDecoration: "none", fontWeight: 500 }}
            >
              Registrujte se ZDE
            </Button>
          </Typography>
          <Typography
  variant="body2"
  sx={{
    color: "#7F96BC",
    textAlign: "center",
    marginTop: 2,
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": { color: "#7F96BC" }
  }}
  onClick={() => {
    closeAllOverlays();
    setIsRequestingReset(true);
  }}
>
  Zapomenuté heslo?
</Typography>


            </Box>
          </Box>

     
        </div>
      )
)}

{activeView === "register" && (
  <div>
    <Box
      sx={{
        position: "relative",
        background: "transparent",
        borderRadius: "20px",
        padding: "1px",
        mt: 2,
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(180deg, rgba(15, 17, 20, 0) 0%, rgba(15, 17, 20, 0.2) 67.31%), #1A1D22",
          border: "0.5px solid #2F353E",
          borderRadius: "20px",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
      <Typography variant="h6" sx={landingTitleSx}>Registrace</Typography>
      <Box sx={landingDividerSx} />
      <TextField
        label="Název týmu"
        value={username}
        fullWidth
        variant="outlined"
        sx={{ ...landingTextFieldSx, mt: 2 }}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        label="Email"
        type="email"
        fullWidth
        variant="outlined"
        sx={{ ...landingTextFieldSx, mt: 2 }}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="Heslo"
        value={loginPasswordInput}
        onChange={(e) => setLoginPasswordInput(e.target.value)}
        type="password"
        fullWidth
        variant="outlined" 
        sx={{ ...landingTextFieldSx, mt: 2 }}
      />
      <TextField
  label="Potvrdit heslo"
  value={confirmPasswordInput}
  onChange={(e) => setConfirmPasswordInput(e.target.value)}
  type="password"
  fullWidth
  variant="outlined"
  sx={{ ...landingTextFieldSx, mt: 2 }}
/>
    <Button
  variant="contained"
  color="primary"
  onClick={() => register(username, email, loginPasswordInput, confirmPasswordInput)}
  sx={{ ...landingButtonSx, mt: 2 }}
>
        Registrovat
      </Button>
       {/* ? NOVÉ TLAČÍTKO "Zpět na přihlášení" */}
       <Box sx={{ textAlign: "center", mt: 2 }}>
<Button variant="text" onClick={closeAllOverlays} 
  sx={{   "&:hover": { color: "#fff" }, display: "block", width:"100%" }}>
  Zpět na přihlášení
</Button>
</Box>
      </Box>
    </Box>
  </div>
)}

 {/* Modální okno pro propojení účtu */}
 <Dialog
  open={connectDialogOpen}
  onClose={() => setConnectDialogOpen(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Propojení účtu
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Hra je již rozehrána, ale není spojena s účtem. Chcete ji propojit s tímto účtem?
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => handleConnectDialogClose(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      Zrušit
    </Button>
    <Button
      variant="contained"
      onClick={() => handleConnectDialogClose(true)}
      sx={{ backgroundColor: "#007bff", color: "#fff", "&:hover": { backgroundColor: "#0056b3" } }}
    >
      Ano
    </Button>
  </DialogActions>
</Dialog>

{/* ? MODÁLNÍ OKNO - HRA SPOJENA S JINÝM ÚČTEM */}
<Dialog
  open={isOtherUserGameOpen}
  onClose={() => setIsOtherUserGameOpen(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Hra je již spojena s jiným účtem
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Tento kód je již spojen s jiným uživatelským jménem. Přihlaste se správným účtem, pokud chcete pokračovat.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={() => setIsOtherUserGameOpen(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

{/* ? MODÁLNÍ OKNO - POKRAČOVAT BEZ PŘIHLÁŠENÍ */}
<Dialog
  open={isLoginOrContinueDialogOpen}
  onClose={() => setIsLoginOrContinueDialogOpen(false)}
  PaperProps={{ sx: dialogPaperSx }}
>
  <DialogTitle sx={dialogTitleSx}>
    Pokračujte bez přihlášení
  </DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ textAlign: "center", color: "#ddd" }}>
      Tento kód je již rozehrán, ale není spojen s účtem. Doporučujeme se přihlásit nebo můžete pokračovat bez přihlášení.
    </Typography>
  </DialogContent>
  <DialogActions sx={dialogActionsSx}>
    <Button
      variant="contained"
      onClick={handleLoginOrContinue}
      sx={{ backgroundColor: "#007bff", color: "#fff", "&:hover": { backgroundColor: "#0056b3" } }}
    >
      Pokračovat bez přihlášení
    </Button>
    <Button
      variant="contained"
      onClick={() => setIsLoginOrContinueDialogOpen(false)}
      sx={{ backgroundColor: "#444", color: "#fff", "&:hover": { backgroundColor: "#666" } }}
    >
      Přihlásit se
    </Button>
  </DialogActions>
</Dialog>





{activeView === "game" && (
<GameLauncher
  gameType={isNewGame ? "outdoor" : gameType}
  uiConfig={isNewGame ? {} : gameUiConfig}
  fallbackTextureUrl={bitwiseGlitch}
>
<Box sx={{ width: "100%", maxWidth: "100%", m: 0, p: 0 }}>
{isNewGame ? (() => {
  const startingPlace = introStartingPlace;
  const gameTitle = introGameTitle;
  return (
  // ?? Úvodní obrazovka při nové hře
  <Paper elevation={3} sx={{ ...gamePaperSx, p: 0 }}>
    <Box sx={{ position: "relative", overflowX: "hidden", backgroundColor: "var(--game-background-color, #0E0E0E)", isolation: "isolate", display: "flex", flexDirection: "column", flex: 1 }}>
      <Box sx={{ position: "absolute", inset: 0, backgroundColor: "var(--game-background-color, #0E0E0E)", zIndex: 0 }} />
      <Box sx={{ position: "absolute", inset: 0, backgroundImage: `url(${activeGameTextureUrl})`,overflowX: "hidden", backgroundRepeat: "repeat", backgroundSize: "auto", mixBlendMode: "soft-light", opacity: activeGameTextureOpacity, pointerEvents: "none", zIndex: 1, maskImage: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 45%, rgba(0,0,0,1) 55%, rgba(0,0,0,1) 100%)", WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,1) 50%, rgba(0,0,0,1) 100%)" }} />
      <Box sx={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", flex: 1 }}>
   <Box
  sx={{
    width: "100%",
    maxWidth: "100%",
    alignSelf: "stretch",
    display: "block",
    aspectRatio: "4/5",
    position: "relative",
    overflow: "hidden",     // ✅ ať se maska drží v radiusu
    borderRadius: "12px",
  }}
>
  {/* ✅ 1) Vrstava jen pro OBRÁZEK – TADY je maska */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",

      WebkitMaskImage:
        "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",
      maskImage:
        "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskSize: "100% 100%",
      maskSize: "100% 100%",
    }}
  />



  {/* ✅ 2) Text overlay – už není pod maskou, bude plně vidět */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      textAlign: "center",
      pb: 2.5,
      px: 2,
      zIndex: 2,
    }}
  >
    <Typography
      variant="h5"
      sx={{
        fontFamily: "'Cactus Classical Serif'",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "22px",
        lineHeight: "23px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#F2EDE4",
        mb: 0.5,

   
      }}
    >
      {gameTitle}
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5 }}>
     <Box
    sx={{
      height: "1px",
      width: { xs: "48px", sm: "80px" },
      background: "linear-gradient(to right, rgba(242, 237, 228, 0) 0%, rgba(242, 237, 228, 0.45) 100%)",
    }}
  />

      <Typography
        variant="body2"
        sx={{
          fontFamily: "'Cactus Classical Serif'",
        
        fontWeight: 400,
          fontSize: "14px",
          lineHeight: "23px",
          textAlign: "center",
          color: "rgba(242, 237, 228, 0.65)",

     
        }}
      >
        Break The Mystery
      </Typography>

    <Box
    sx={{
      height: "1px",
      width: { xs: "48px", sm: "80px" },
      background: "linear-gradient(to right, rgba(242, 237, 228, 0.45) 0%, rgba(242, 237, 228, 0) 100%)",
    }}
  />
    </Box>
  </Box>
</Box>
    <Box sx={{ px: 2, pb: 3, pt: 2, display: "flex", flexDirection: "column", flex: 1 }}>
      {introAudio && (
        <Box sx={{ mt: 2, mb: 1.5, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Box sx={{ width: "min(520px, 92%)", display: "flex", alignItems: "center", gap: 1.5 }}>
            <IconButton
              onClick={() => {
                const audio = introAudioRef.current;
                if (!audio) return;
                if (audio.paused) {
                  audio.play();
                  setIsIntroAudioPlaying(true);
                } else {
                  audio.pause();
                  setIsIntroAudioPlaying(false);
                }
              }}
              sx={{
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.25)",
                width: 36,
                height: 36,
              }}
            >
              {isIntroAudioPlaying ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
            </IconButton>
            <Slider
              size="small"
              value={introAudioProgress}
              min={0}
              max={introAudioDuration || 0}
              onChange={(_, value) => {
                const audio = introAudioRef.current;
                if (!audio || typeof value !== "number") return;
                audio.currentTime = value;
                setIntroAudioProgress(value);
              }}
              sx={{
                color: "rgba(255,255,255,0.8)",
                "& .MuiSlider-rail": { opacity: 0.2, height: 3 },
                "& .MuiSlider-track": { height: 3 },
                "& .MuiSlider-thumb": { width: 10, height: 10 },
              }}
            />
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", minWidth: 70 }}>
              {introAudioDuration
                ? `${Math.floor(introAudioProgress / 60)}:${String(Math.floor(introAudioProgress % 60)).padStart(2, "0")}`
                : "0:00"}
              {" / "}
              {introAudioDuration
                ? `${Math.floor(introAudioDuration / 60)}:${String(Math.floor(introAudioDuration % 60)).padStart(2, "0")}`
                : "0:00"}
            </Typography>
          </Box>
          <audio
            ref={introAudioRef}
            src={introAudio}
            preload="metadata"
            onTimeUpdate={(event) => {
              const current = event.currentTarget.currentTime || 0;
              const duration = event.currentTarget.duration || 0;
              setIntroAudioProgress(current);
              setIntroAudioDuration(duration);
            }}
            onLoadedMetadata={(event) => {
              setIntroAudioDuration(event.currentTarget.duration || 0);
            }}
            onEnded={() => {
              setIsIntroAudioPlaying(false);
            }}
            onPlay={() => setIsIntroAudioPlaying(true)}
            onPause={() => setIsIntroAudioPlaying(false)}
            style={{ display: "none" }}
          >
            <source src={introAudio} />
            Váš prohlížeč nepodporuje přehrávání audia.
          </audio>
        </Box>
      )}
      <Typography
        variant="body1"
        sx={{
          whiteSpace: "pre-line",
          textAlign: "center",
          fontFamily: "'Cactus Classical Serif', serif",
          fontWeight: 400,
          fontSize: "13px",
          lineHeight: "23px",
          color: "#FFFFFF",
        }}
      >
        {introText}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1, mt: 2, color: "#D8D3C8" }}>
        <LocationOnIcon sx={{ fontSize: 18, color: "#D8D3C8" }} />
        <Typography variant="body2" sx={{ fontFamily: "'Cactus Classical Serif', serif", fontWeight: 400, fontSize: "13px", lineHeight: "22px", color: "#D8D3C8" }}>
          {startingPlace}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, mt: "auto", width: "100%" }}>
        <Button
  variant="contained"
  disableRipple
  sx={{
    width: "min(520px, 92%)",
    minHeight: 52,
    borderRadius: "20px",
    position: "relative",
    overflow: "hidden",
    background: "transparent",
    color: "#F2EDE4",
    border: "none",
    boxShadow: "none",
    padding: "12px 20px",
    fontFamily: "'Cactus Classical Serif', serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "23px",
    textAlign: "center",
    textTransform: "uppercase",
    transition: "all 0.3s ease",

    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "20px",
      background:
        "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
      border: "0.5px solid #1B1B1B",
      boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
      pointerEvents: "none",
      zIndex: 0,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      inset: "1px",
      borderRadius: "19px",
      background:
        "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
      border: "1px solid rgba(242, 237, 228, 0.08)",
      pointerEvents: "none",
      zIndex: 1,
    },

    "& > *": { position: "relative", zIndex: 2 },

    "&:hover": {
      "&::after": { border: "1px solid rgba(242, 237, 228, 0.14)" },
      "&::before": { boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)" },
    },
  }}
  onClick={handleOpenRules}
>
  <span style={{ display: "inline-block" }}>PRAVIDLA</span>
</Button>
<Button
  variant="contained"
  disableRipple
  sx={{
    width: "min(520px, 92%)",
    minHeight: 52,
    borderRadius: "20px",
    position: "relative",
    overflow: "hidden",
    background: "transparent",
    color: "#F2EDE4",
    border: "none",
    boxShadow: "none",
    padding: "12px 20px",
    fontFamily: "'Cactus Classical Serif', serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "23px",
    textAlign: "center",
    textTransform: "uppercase",
    transition: "all 0.3s ease",

    // ✅ VZHLED (stejný jako ZPĚT)
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "20px",
      background:
        "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
      border: "0.5px solid #1B1B1B",
      boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
      pointerEvents: "none",
      zIndex: 0,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      inset: "1px",
      borderRadius: "19px",
      background:
        "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
      border: "1px solid rgba(242, 237, 228, 0.08)",
      pointerEvents: "none",
      zIndex: 1,
    },

    "& > *": { position: "relative", zIndex: 2 },

    "&:hover": {
      "&::after": { border: "1px solid rgba(242, 237, 228, 0.14)" },
      "&::before": { boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)" },
    },
  }}
  disabled={isActionLocked}
  onClick={startNewGame}
>
  <span style={{ display: "inline-block" }}>VSTOUPIT DO PŘÍBĚHU</span>
</Button>

        <Button
          variant="contained"
          color="primary"
          sx={{
            width: "min(520px, 92%)",
            minHeight: 52,
            borderRadius: "20px",
            position: "relative",
            overflowX: "hidden",
            background: "transparent",
            color: "#F2EDE4",
            border: "none",
            boxShadow: "none",
            padding: "12px 20px",
            fontFamily: "'Cactus Classical Serif', serif",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "23px",
            textAlign: "center",
            textTransform: "uppercase",
            transition: "all 0.3s ease",
            "& > *": { position: "relative", zIndex: 1 },
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              borderRadius: "20px",
              background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
              border: "0.5px solid #1B1B1B",
              boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
              pointerEvents: "none",
              zIndex: 0,
            },
            "&::after": {
              content: '""',
              position: "absolute",
              inset: "1px",
              borderRadius: "19px",
              background: "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
              border: "1px solid rgba(242, 237, 228, 0.08)",
              pointerEvents: "none",
              zIndex: 0,
            },
            "&:hover": {
              "&::after": {
                border: "1px solid rgba(242, 237, 228, 0.14)",
              },
              "&::before": {
                boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)",
              },
            },
          }}
          onClick={QuitSave}
        >
          <span style={{ position: "relative", zIndex: 1, display: "inline-block" }}>
            ZPĚT
          </span>
        </Button>
      </Box>
    </Box>
        </Box>
    </Box>
  </Paper>
  );
  })() : gameType === "escape_box" ? (
    <EscapeBoxGameScreen
      backendUrl={backendUrl}
      code={activeGameCode || gameCode}
      userId={userId}
      onQuit={QuitSave}
    />
  ) : isGameCompleted ? (
  <Paper
    elevation={3}
    sx={{
      ...gamePaperSx,
      p: 0,
      backgroundColor: "var(--game-background-color, #0E0E0E)",
      border: { xs: "none", sm: "1px solid rgba(242, 237, 228, 0.08)" },
      boxShadow: { xs: "none", sm: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)" },
    }}
  >
    <Box
      sx={{
        position: "relative",
        overflowX: "hidden",
        backgroundColor: "var(--game-background-color, #0E0E0E)",
        isolation: "isolate",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: { xs: "100dvh", sm: "auto" },
      }}
    >
      {/* BG + glitch */}
      <Box sx={{ position: "absolute", inset: 0, backgroundColor: "var(--game-background-color, #0E0E0E)", zIndex: 0 }} />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${activeGameTextureUrl})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          mixBlendMode: "soft-light",
          opacity: activeGameTextureOpacity,
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      {/* Hero image (fade do průhledna) */}
    {!!(gameHeroUrl || imageUrl) && (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 0,
      pointerEvents: "none",
    }}
  >
          <Box
            sx={{
              width: "100%",
              aspectRatio: "4 / 5",
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={gameHeroUrl || imageUrl}
              alt=""
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                WebkitMaskImage:
                  "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 62%, rgba(0,0,0,0) 100%)",
                maskImage:
                  "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 62%, rgba(0,0,0,0) 100%)",
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
              }}
            />
          </Box>

          {/* top dark overlay */}
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: "35%",
              background: "linear-gradient(to bottom, rgba(14,14,14,0.92) 0%, rgba(14,14,14,0) 100%)",
              pointerEvents: "none",
            }}
          />
        </Box>
      )}

      {/* Content */}
    <Box
  sx={{
    position: "relative",
    zIndex: 2,
    px: { xs: 2, sm: 3 },
    pt: { xs: 4, sm: 5 },  // ✅ přidat tohle
    pb: { xs: 3, sm: 3 },
  }}
>
  {/* Název hry */}
<Typography
  sx={{
    fontFamily: "'Cinzel', serif",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    fontWeight: 600,
    fontSize: "clamp(18px, 2.8vw, 28px)",
    textAlign: "center",
    color: "#F2EDE4",
    textShadow: "0 2px 0 rgba(0,0,0,0.70)",
    mt: { xs: 2.5, sm: 3 },
  }}
>
 {finalTitle}
</Typography>

{/* BREAK THE MYSTERY + čáry z obou stran */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    mt: 1.2,
       mb: 3,   // ← přidá mezeru pod celý blok
  }}
>
  {/* Levá čára */}
  <Box
    sx={{
      flex: 1,
      height: "2px",
    background:
  "linear-gradient(90deg, rgba(242,237,228,0.2) 0%, rgba(242,237,228,0.8) 100%)",
    }}
  />

  {/* Text */}
  <Typography
    sx={{
      fontFamily: "'Cinzel', serif",
      textTransform: "uppercase",
      letterSpacing: "0.25em",
      fontSize: "11px",
      color: "rgba(242,237,228,0.65)",
      whiteSpace: "nowrap",
    }}
  >
    Break The Mystery
  </Typography>

  {/* Pravá čára */}
  <Box
    sx={{
      flex: 1,
      height: "2px",
   background:
  "linear-gradient(270deg, rgba(242,237,228,0.2) 0%, rgba(242,237,228,0.8) 100%)",
    }}
  />
</Box>

        {/* End message card */}
        <Box sx={{ ...panelSoft3DSx, p: 2.2, mb: 2.2 }}>
          <Typography
            sx={{
              color: "rgba(242,237,228,0.86)",
              fontFamily: "'Cactus Classical Serif', serif",
              fontSize: "14.5px",
              lineHeight: 1.7,
              whiteSpace: "pre-line",
              textAlign: "center",
            }}
          >
            {sanitizeHtml(endMessage)}
          </Typography>
        </Box>

        {/* Stats row: rating + time */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 1.6,
            mb: 2.2,
          }}
        >
          <Box sx={{ ...panelSoft3DSx, p: 2 }}>
            <Typography
              sx={{
                fontFamily: "'Cinzel', serif",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontSize: 13,
                color: "rgba(242,237,228,0.75)",
                mb: 1,
                textAlign: "center",
              }}
            >
              Hodnocení
            </Typography>

            {/* Použijeme tvoje hvězdy – jen na finální rating */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {(() => {
                const saved = rating;
                // dočasně přepneme rating renderu hvězd na finalRating
                // (nejjednodušší bez přepisování renderStars)
                // pokud chceš čistě, uděláme renderStarsFor(value) později
                return (
                  <div style={{ transform: "translateY(-2px)" }}>
                    {(() => {
                      const full = Math.floor(finalRating);
                      const half = finalRating % 1 !== 0;
                      const empty = 10 - full - (half ? 1 : 0);
                      return (
                        <div style={{ display: "flex", gap: "2px", justifyContent: "center" }}>
                          {Array(full).fill(null).map((_, i) => (
                            <span key={`f-${i}`} style={{ display: "inline-flex" }}>
                              <StarSvg variant="full" />
                            </span>
                          ))}
                          {half && (
                            <span key="h" style={{ display: "inline-flex" }}>
                              <StarSvg variant="half" />
                            </span>
                          )}
                          {Array(empty).fill(null).map((_, i) => (
                            <span key={`e-${i}`} style={{ display: "inline-flex" }}>
                              <StarSvg variant="empty" />
                            </span>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                );
              })()}
            </Box>

            <Typography
              sx={{
                mt: 1,
                textAlign: "center",
                color: "rgba(242,237,228,0.78)",
                fontFamily: "'Cactus Classical Serif', serif",
                fontSize: 13,
              }}
            >
              {finalRating} / 10
            </Typography>
          </Box>

          <Box sx={{ ...panelSoft3DSx, p: 2 }}>
            <Typography
              sx={{
                fontFamily: "'Cinzel', serif",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontSize: 13,
                color: "rgba(242,237,228,0.75)",
                mb: 1,
                textAlign: "center",
              }}
            >
              Celkový čas
            </Typography>

            <Typography
              sx={{
                textAlign: "center",
                color: "#F2EDE4",
                fontFamily: "'Cactus Classical Serif', serif",
                fontSize: 18,
                textShadow: "0 2px 0 rgba(0,0,0,0.65)",
              }}
            >
           {(() => {
  const total = Math.floor(finalElapsedTime);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return `${String(hours).padStart(2, "0")}h:${String(minutes).padStart(2, "0")}m:${String(seconds).padStart(2, "0")}s`;
})()}
            </Typography>

       
          </Box>
        </Box>

        {/* Decision stats */}
        <Box sx={{ ...panelSoft3DSx, p: 2.2, mb: 2.2 }}>
          <Typography
            sx={{
              fontFamily: "'Cinzel', serif",
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontSize: 13,
              color: "rgba(242,237,228,0.75)",
              mb: 1.2,
              textAlign: "center",
            }}
          >
            Jak se rozhodovali ostatní
          </Typography>

          {decisionStatsLoading && (
            <Typography sx={{ color: "rgba(242,237,228,0.55)", fontFamily: "'Cactus Classical Serif', serif", fontSize: 13, textAlign: "center" }}>
              Načítám statistiky…
            </Typography>
          )}

          {decisionStatsError && (
            <Typography sx={{ color: "rgba(255,130,130,0.85)", fontFamily: "'Cactus Classical Serif', serif", fontSize: 13, textAlign: "center" }}>
              {decisionStatsError}
            </Typography>
          )}

          {!decisionStatsLoading && decisionStats?.moments?.length > 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.6 }}>
              {decisionStats.moments.map((m) => {
                const total = Number(m.total || 0);
                const hasData = total > 0;

                return (
                  <Box
                    key={m.momentId}
                    sx={{
                      border: "1px solid rgba(242,237,228,0.10)",
                      borderRadius: "16px",
                      background: "rgba(0,0,0,0.28)",
                      p: 1.6,
                    }}
                  >
                    <Typography sx={{ color: "#F2EDE4", fontFamily: "'Cinzel', serif", fontSize: 14.5, mb: 0.5 }}>
                      {m.title}
                    </Typography>
                    <Typography sx={{ color: "rgba(242,237,228,0.65)", fontFamily: "'Cactus Classical Serif', serif", fontSize: 13, mb: 1.2 }}>
                      {m.question}
                    </Typography>

                    {!hasData ? (
                      <Typography sx={{ color: "rgba(242,237,228,0.45)", fontFamily: "'Cactus Classical Serif', serif", fontSize: 12.5 }}>
                        Zatím nemáme data.
                      </Typography>
                    ) : (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.1 }}>
                        {m.options.map((opt) => (
                          <Box key={opt.optionId}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, mb: 0.4 }}>
                              <Typography sx={{ color: "#F2EDE4", fontFamily: "'Cactus Classical Serif', serif", fontSize: 13 }}>
                                {opt.label}
                              </Typography>
                              <Typography sx={{ color: "rgba(242,237,228,0.9)", fontFamily: "'Cinzel', serif", fontSize: 13 }}>
                                {Math.round(opt.percent)}%
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                height: 10,
                                borderRadius: 99,
                                overflow: "hidden",
                                background: "rgba(242,237,228,0.10)",
                              }}
                            >
                              <Box
                                sx={{
                                  width: `${opt.percent}%`,
                                  height: "100%",
                                  background: "rgba(242,237,228,0.55)",
                                }}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>

        {/* CTA Buttons (ve tvém 3D stylu) */}
      <Box
  sx={{
    mt: "auto",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1.6,
    pb: 1,
  }}
>
  {userId && reviewToken && <InlineReviewForm token={reviewToken} />}

  {userId && !reviewToken && (reviewTokenLoading || reviewTokenError) && (
    <Box sx={{ ...panelSoft3DSx, width: "100%", p: 2.2, textAlign: "center" }}>
      <Typography
        sx={{
          fontFamily: "'Cinzel', serif",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          fontSize: 13,
          color: "rgba(242,237,228,0.75)",
          mb: 0.8,
        }}
      >
        Recenze
      </Typography>
      <Typography
        role={reviewTokenError ? "alert" : "status"}
        sx={{
          color: reviewTokenError ? "rgba(255,130,130,0.9)" : "rgba(242,237,228,0.62)",
          fontFamily: "'Cactus Classical Serif', serif",
          fontSize: 13,
        }}
      >
        {reviewTokenError || "Načítám hodnocení…"}
      </Typography>
    </Box>
  )}

  <Box
    onClick={() => {
      setIsInGame(false);
      if (userId) loadUserGames(userId);
    }}
    sx={{
      ...panelSoft3DSx,
      width: "min(520px, 92%)",
      p: 2,
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        border: "1px solid rgba(242,237,228,0.18)",
        background: "rgba(0,0,0,0.45)",
      },
    }}
  >
    <Typography
      sx={{
        fontFamily: "'Cinzel', serif",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        fontSize: 13,
        color: "#F2EDE4",
      }}
    >
      Opustit hru
    </Typography>
  </Box>
</Box>
      </Box>
    </Box>
  </Paper>
) :   isStoryScreen ? (  



<>

  <Paper
    elevation={3}
    sx={{
      ...gamePaperSx,
      p: 0,
      backgroundColor: "var(--game-background-color, #0E0E0E)",
      border: { xs: "none", sm: "1px solid rgba(242, 237, 228, 0.08)" },
      boxShadow: { xs: "none", sm: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)" },
      zIndex: 0,
    }}
  >
    <Box sx={{ position: "relative", overflowX: "hidden", backgroundColor: "var(--game-background-color, #0E0E0E)", isolation: "isolate", display: "flex", flexDirection: "column", flex: 1 }}>
      <Box sx={{ position: "absolute", inset: 0, backgroundColor: "var(--game-background-color, #0E0E0E)", zIndex: 0 }} />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${activeGameTextureUrl})`,
          overflowX: "hidden",
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          mixBlendMode: "soft-light",
          opacity: activeGameTextureOpacity,
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <Box sx={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", flex: 1 }}>
{/* 🔥 Tlačítko Uložit a Ukončit (Top Left) */}
  <IconButton
    onClick={QuitSave}
    disableRipple
    sx={{
      position: "absolute",
      left: { xs: 16, sm: 24 },
      top: { xs: 20, sm: 28 }, // Zarovnáno opticky naproti hamburger menu
      zIndex: 200,
      color: "rgb(255, 255, 255)",
      padding: 0,
      "&:hover": { color: "#F2EDE4", backgroundColor: "transparent" },
    }}
  >
    <LogoutOutlinedIcon sx={{ fontSize: 32 }} />
  </IconButton>
      <Box sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 3 } }}>


{/* Název hry */}

<Typography
  variant="h6"
  sx={{
    fontFamily: "'Cactus Classical Serif', serif",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 400,
    fontSize: "clamp(18px, 2.4vw, 28px)",
    lineHeight: 1.1,
    textAlign: "center",
    color: "#F2EDE4",
    textShadow: "0 2px 0 rgba(0,0,0,0.70), 0 0 14px rgba(242,237,228,0.12)",
    marginBottom: "4px",
    mt: 1,
    position: "relative", zIndex: 10
  }}
>
  {NazevHry}
</Typography>

        {/* Zobrazení hodnocení hvězdičkami */}

        <Box
          sx={{
            height: "1px",
            width: "min(720px, 92%)",
            background: "linear-gradient(to right, rgba(242,237,228,0) 0%, rgba(242,237,228,0.45) 50%, rgba(242,237,228,0) 100%)",
            boxShadow: "0 0 12px rgba(242,237,228,0.2)",
            mx: "auto",
            mt: "6px",
            mb: "2px",
            opacity: 0.9,
            position: "relative", zIndex: 10
          }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 1,position: "relative", zIndex: 10 }}>
          {renderStars()}
        </Box>
        {console.log("?? Zobrazení elapsedTime v UI:", elapsedTime)}
      </Box>
          <Box sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2.5, sm: 3 }, display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
 {/* OBRÁZEK - S úpravou pro posun nahoru pod hvězdy */}
{imageUrl && (screenType === 2 ? (
  <Box
    sx={{
      // 1. Roztáhneme do krajů
      mx: { xs: -2, sm: -3 },
      width: { xs: "calc(100% + 32px)", sm: "calc(100% + 48px)" },
      maxWidth: "none",
      
      // 2. Posuneme nahoru pod hvězdičky (negativní margin-top)
      mt: { xs: -4, sm: -5 }, 
      
      // 3. Prolnutí s textem dole (negativní margin-bottom)
      mb: { xs: -8, sm: -10 }, 

     aspectRatio: "4 / 5",
height: "auto",
      position: "relative",

      zIndex: 0, // Obrázek je vespod (hvězdy nad ním mají defaultní vyšší prioritu v tomto kontextu)
       mt: "-100px",
      // ✅ aby se to neuseklo, přidáme zpátky trochu paddingu nahoře jako prostor pro navbar
      borderRadius: 0,
      display: "block",
       "&::before": {
        content: '""',

        position: "absolute",
        inset: 0,
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",

        // ✅ Fade obrázku do průhledna jen dole (30 % výšky)
        // 0% (úplně dole) = 0 (neviditelné)
        // 30% = 1 (plně viditelné)
        WebkitMaskImage:
          "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",
        maskImage:
          "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",
                 WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
      },
    }}
  >

    {/* 2. Gradient nahoře (pro hvězdičky a nadpis) - NOVÉ */}
    <Box
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0, // Přilepený nahoru
        height: "10%", // Výška gradientu (aby zakryl horní část, ale ne střed obrázku)
        // Gradient jde od plné barvy (nahoře) do průhledné (dole)
        background: "linear-gradient(to bottom, rgba(14,14,14,0.5) 0%, rgba(14,14,14,0) 100%)",
        zIndex: 1,
      }}
    />
  </Box>
) : (
  <img 
    src={imageUrl} 
    alt="Ilustrační obrázek" 
    onClick={() => setIsImageOverlayOpen(true)}
    style={{ 
      width: "100%", maxWidth: "100%", height: "auto", maxHeight: "300px", objectFit: "contain", 
      marginTop: "10px", marginBottom: "16px", display: "block", borderRadius: "8px" ,cursor: "zoom-in",
WebkitTapHighlightColor: "transparent"
    }} 
  />
))}

{renderScreenType2ImageZoomButton()}

{/* AUDIO PŘEHRÁVAČ (pokud existuje) */}
{storyAudio && (
  <Box sx={{ ...audioContainerStyle, position: "relative", zIndex: 2 }}>
    <audio controls style={{ width: "100%", backgroundColor: "#111", borderRadius: "8px", colorScheme: "dark" }}>
      <source src={storyAudio} />
      Váš prohlížeč nepodporuje přehrávání audia.
    </audio>
  </Box>
)}

{/* TEXTY - Obalené v Boxu s vysokým z-indexem, aby byly PŘED obrázkem */}
<Box sx={{ position: "relative", zIndex: 2, px: 1 }}>
  {headline && (
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "pre-line", mb: 1, fontFamily: "'Cactus Classical Serif', serif",
        fontWeight: 400, fontSize: "15px", lineHeight: "23px", textAlign: "center", color: "#F2EDE4",// --- PŘIDÁNO: RESET VNITŘNÍCH STYLŮ ---
        // Toto zajistí, že i když je v DB <h3> nebo <b>,
        // převezme to velikost a styl definovaný tady v Typography.
        "& *": {
          fontFamily: "inherit !important",
          fontSize: "inherit !important",
          fontWeight: "inherit !important",
          color: "inherit !important",
          margin: 0,
          lineHeight: "inherit",
        }
        // --------------------------------------
      }}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(headline) }}
    />
  )}
{renderTextWithVoiceMarkers(storyText)}
{renderNextInstructionSection()}
</Box>

 <Box sx={{ mt: "auto", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
  <Button 
    variant="contained" 
    // Pro jistotu můžeš color="primary" úplně smazat, když si barvy děláš vlastní
    disableRipple
    disableFocusRipple
    disableTouchRipple
    sx={{
      position: "relative",
      overflowX: "hidden",
      width: "min(520px, 92%)",
      minHeight: 48,
      background: "transparent",
      color: "#F2EDE4",
      border: "none",
      boxShadow: "none",
      padding: "10px 20px",
      fontFamily: "'Cactus Classical Serif', serif",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "23px",
      textAlign: "center",
      textTransform: "uppercase",
      transition: "all 0.3s ease",
      mx: "auto",
      backgroundColor: "transparent",
      
      // ✅ Zde je pouze JEDEN sloučený hover efekt
      "&:hover": {
        backgroundColor: "transparent",
        "&::after": { 
          border: "1px solid rgba(242, 237, 228, 0.14)" 
        },
        "&::before": { 
          boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)" 
        },
      },
      
      "&:focus": { outline: "none" },
      "&:focus-visible": { outline: "none" },
      "&.Mui-focusVisible": { outline: "none", boxShadow: "none" },
      "&.MuiButtonBase-root:focus": { outline: "none" },
      
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: "20px",
        background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
        border: "0.5px solid #1B1B1B",
        boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
        pointerEvents: "none",
        zIndex: 0,
      },
      
      "&::after": {
        content: '""',
        position: "absolute",
        inset: "1px",
        borderRadius: "19px",
        background: "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
        border: "1px solid rgba(242, 237, 228, 0.08)",
        pointerEvents: "none",
        zIndex: 0,
      },
      mt: 2,
    }} 
    disabled={isActionLocked}
    onClick={() => {
      console.log("?? Story screen potvrzen! Posouvám dál...");
      const codeToUse = activeGameCode || gameCode;
      
      if (!codeToUse || currentQuestion === undefined) {
        console.error("? gameCode nebo currentQuestion není definováno! Není možné načíst další otázku.");
        return;
      }
  
      const nextQuestion = currentQuestion + 1;
      console.log(`?? Posílám na backend: ${codeToUse}, další otázka: ${nextQuestion}`);
  
      submitAnswer("story_screen");
    }}
  >
    <span style={{ position: "relative", zIndex: 1, display: "inline-block" }}>
      {isLastQuestion ? "Ukončit hru a zastavit časomíru" : storyButtonText}
    </span>
  </Button>
 {!!startTime && !isGameCompleted && (        
    <Typography
      variant="caption"
      sx={{
        mt: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        fontFamily: "'Cactus Classical Serif', serif",
        fontWeight: 400,
        fontSize: "11px",
        lineHeight: "17px",
        color: "rgba(255, 255, 255, 0.6)",
      }}
    >
      {ICON_STOPWATCH} {Math.floor(elapsedTime / 60)} min {elapsedTime % 60} s
    </Typography>
    
  )}
   
  </Box>
      </Box>
    </Box>
    {renderMapOverlay()}
    {renderImageOverlay()}
    </Box>
  </Paper>
</>
) :



(
  // ?? Zobrazení otázky (běžná herní obrazovka)

  
  // Obalíme více operací do jednoho bloku
  <>
    {console.log("currentQuestion:", currentQuestion)}
    {console.log("questionText:", question)}
    {currentQuestion !== null && question && (
      <Paper
        elevation={3}
        sx={{
          ...gamePaperSx,
          p: 0,
          backgroundColor: "var(--game-background-color, #0E0E0E)",
          border: { xs: "none", sm: "1px solid rgba(242, 237, 228, 0.08)" },
          boxShadow: { xs: "none", sm: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)" },
          zIndex: 0,
        }}
      >
        <Box sx={{ position: "relative", overflowX: "hidden", backgroundColor: "var(--game-background-color, #0E0E0E)", isolation: "isolate", display: "flex", flexDirection: "column", flex: 1 }}>
          <Box sx={{ position: "absolute", inset: 0, backgroundColor: "var(--game-background-color, #0E0E0E)", zIndex: 0 }} />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${activeGameTextureUrl})`,
              overflowX: "hidden",
              backgroundRepeat: "repeat",
              backgroundSize: "auto",
              mixBlendMode: "soft-light",
              opacity: activeGameTextureOpacity,
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
          <Box sx={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", flex: 1 }}>
            {/* 🔥 Tlačítko Uložit a Ukončit (Top Left) */}
  <IconButton
    onClick={QuitSave}
    disableRipple
    sx={{
      position: "absolute",
      left: { xs: 16, sm: 24 },
      top: { xs: 20, sm: 28 }, // Zarovnáno opticky naproti hamburger menu
      zIndex: 200,
      color: "rgb(242, 237, 228)",
      padding: 0,
      "&:hover": { color: "#F2EDE4", backgroundColor: "transparent" },
    }}
  >
    <LogoutOutlinedIcon sx={{ fontSize: 32 }} />
  </IconButton>
            <Box sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 3 } }}>
   {/* Název hry */}
   <Typography
     variant="h6"
    sx={{
       fontFamily: "'Cactus Classical Serif', serif",
       textTransform: "uppercase",
       letterSpacing: "0.06em",
       fontWeight: 400,
       fontSize: "clamp(18px, 2.4vw, 28px)",
       lineHeight: 1.1,
       textAlign: "center",
       color: "#F2EDE4",
       textShadow: "0 2px 0 rgba(0,0,0,0.70), 0 0 14px rgba(242,237,228,0.12)",
       marginBottom: "4px",
       mt: 1,position: "relative", zIndex: 10
     }}
   >
      {NazevHry}
    </Typography>

            {/* Zobrazení hodnocení hvězdičkami */}
            <Box
              sx={{
                height: "1px",
                width: "min(720px, 92%)",
                background: "linear-gradient(to right, rgba(242,237,228,0) 0%, rgba(242,237,228,0.45) 50%, rgba(242,237,228,0) 100%)",
                boxShadow: "0 0 12px rgba(242,237,228,0.2)",
                mx: "auto",
                mt: "6px",
                mb: "2px",
                opacity: 0.9,position: "relative", zIndex: 10
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 1,position: "relative", zIndex: 10 }}>
              {renderStars()}
            </Box>
            </Box>
            <Box sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2.5, sm: 3 }, display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>


       {/*  <Typography variant="h6">Otázka č. {currentQuestion}</Typography> */}
    {imageUrl && (screenType === 2 ? (
  <Box
    sx={{
      mx: { xs: -2, sm: -3 },
      width: { xs: "calc(100% + 32px)", sm: "calc(100% + 48px)" },
      maxWidth: "none",
      mt: { xs: -4, sm: -5 }, // Posun nahoru pod hvězdy/nadpis
      mb: { xs: -8, sm: -10 }, // Prolnutí s textem
  aspectRatio: "4 / 5",
height: "auto",
      position: "relative",

      zIndex: 0,
      borderRadius: 0,
      display: "block",
            // ✅ TOTO je ta změna: vytáhne obrázek až nahoru (pod fixed navbar)
      mt: "-100px",
      // ✅ aby se to neuseklo, přidáme zpátky trochu paddingu nahoře jako prostor pro navbar
     // pt: "50px",
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",

        // ✅ Fade obrázku do průhledna jen dole (30 % výšky)
        // 0% (úplně dole) = 0 (neviditelné)
        // 30% = 1 (plně viditelné)
        WebkitMaskImage:
          "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",
        maskImage:
          "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 8%, rgba(0,0,0,0.45) 16%, rgba(0,0,0,0.75) 24%, rgba(0,0,0,1) 30%, rgba(0,0,0,1) 100%)",

                 WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
      },
    }}
  >
 
    {/* 2. Gradient nahoře (pro hvězdičky a nadpis) - NOVÉ */}
    <Box
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0, // Přilepený nahoru
        height: "10%", // Výška gradientu (aby zakryl horní část, ale ne střed obrázku)
        // Gradient jde od plné barvy (nahoře) do průhledné (dole)
        background: "linear-gradient(to bottom, rgba(14,14,14,0.5) 0%, rgba(14,14,14,0) 100%)",
        zIndex: 1,
      }}
    />
  </Box>
) : (
  <img 
    src={imageUrl} 
    alt="Ilustrační obrázek" 
      onClick={() => setIsImageOverlayOpen(true)}
    style={{ 
      width: "100%", maxWidth: "100%", height: "auto", maxHeight: "300px", objectFit: "contain", 
      marginTop: "10px", marginBottom: "16px", display: "block", borderRadius: "8px" ,cursor: "zoom-in",
WebkitTapHighlightColor: "transparent"
    }} 
  />
))}

{renderScreenType2ImageZoomButton()}

{audioUrl && (
  <Box sx={{ ...audioContainerStyle, position: "relative", zIndex: 2 }}>
    <audio controls style={{ width: "100%", backgroundColor: "#111", borderRadius: "8px", colorScheme: "dark" }}>
      <source src={audioUrl} />
      Váš prohlížeč nepodporuje přehrávání audia.
    </audio>
  </Box>
)}

{/* TEXTY - Obalené pro zobrazení PŘED obrázkem */}
<Box sx={{ position: "relative", zIndex: 2, px: 1 }}>
  {headline && (
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "pre-line", mb: 1, fontFamily: "'Cactus Classical Serif', serif",
        fontWeight: 400, fontSize: "15px", lineHeight: "23px", textAlign: "center", color: "#F2EDE4",// --- PŘIDÁNO: RESET VNITŘNÍCH STYLŮ ---
        // Toto zajistí, že i když je v DB <h3> nebo <b>,
        // převezme to velikost a styl definovaný tady v Typography.
        "& *": {
          fontFamily: "inherit !important",
          fontSize: "inherit !important",
          fontWeight: "inherit !important",
          color: "inherit !important",
          margin: 0,
          lineHeight: "inherit",
        }
        // --------------------------------------
      }}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(headline) }}
    />
  )}

  {questionTimed && questionTimeLeft != null && (
  <div style={{ textAlign: "center", marginTop: 8, opacity: 0.85, fontWeight: 700 }}>
    ⏳ Zbývá: {questionTimeLeft}s
  </div>
)}

  {renderTextWithVoiceMarkers(question)}
 {renderNextInstructionSection()}
</Box>

        <Box sx={{ mt: "auto", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
{isMultipleChoice ? (
  <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 1.2 }}>
    {(Array.isArray(choices) ? choices : []).map((choice, index) => {
      const selected = selectedAnswers.includes(choice);
      const letter = String.fromCharCode(65 + index);
      return (
        <Button
          key={index}
          onClick={() => toggleChoice(choice)}
          disableRipple
          disableElevation
          sx={getChoiceButtonSx(selected)}
        >
          <Box
            component="span"
            sx={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              width: "100%",
              minHeight: 46,
              px: 1.2,
              py: 0.75,
              gap: 1.2,
              boxSizing: "border-box",
            }}
          >
            <Box
              component="span"
              sx={{
                width: 46,
                height: 34,
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                color: "#D8D3C8",
                border: "1px solid rgba(242,237,228,0.14)",
                background: "linear-gradient(180deg, rgba(242,237,228,0.06) 0%, rgba(0,0,0,0) 100%)",
                boxShadow: selected
                  ? "0 0 0 1px rgba(242,237,228,0.22)"
                  : "none",
              }}
            >
              {letter}
            </Box>
            <Box
              component="span"
              sx={{
                flex: 1,
                textAlign: "center",
                pr: 4,
                color: "#F2EDE4",
                textShadow: "0 1px 0 rgba(0,0,0,0.65)",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                lineHeight: 1.35,
              }}
            >
              {choice}
            </Box>
          </Box>
        </Button>
      );
    })}
  </Box>
) : (
                <Box sx={{ width: "min(520px, 92%)", display: "flex", alignItems: "center", gap: 2, mt: 2, mx: "auto" }}>
                  <Box
                    sx={{
                      flex: 1,
                      height: 48,
                      position: "relative",
                      overflowX: "hidden",
                      borderRadius: "999px",
                      background: "transparent",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        borderRadius: "999px",
                        background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                        border: "0.5px solid #1B1B1B",
                        boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
                        pointerEvents: "none",
                        zIndex: 0,
                      },
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        inset: "1px",
                        borderRadius: "999px",
                        background: "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                        border: "1px solid rgba(242, 237, 228, 0.08)",
                        pointerEvents: "none",
                        zIndex: 0,
                      },
                    }}
                  >
                    <TextField
                      id="answerInput"
                      placeholder="ZADEJTE ODPOVĚĎ"
                      value={answerText}
                      onChange={(e) => setAnswerText(e.target.value)}
                      fullWidth
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        position: "relative",
                        zIndex: 1,
                        height: 48,
                        "& .MuiInputBase-root": {
                          height: 48,
                          display: "flex",
                          alignItems: "center",
                          px: 3,
                        },
                        input: {
                          color: "#F2EDE4",
                          WebkitTextFillColor: "#F2EDE4",
                          fontFamily: "'Cactus Classical Serif', serif",
                          textAlign: "center",
                          lineHeight: "48px",
                          height: 48,
                          p: 0,
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "rgba(242, 237, 228, 0.23)",
                          opacity: 1,
                          WebkitTextFillColor: "rgba(242, 237, 228, 0.23)",
                          textTransform: "uppercase",
                        },
                        "& .MuiInputBase-input::-webkit-input-placeholder": {
                          color: "rgba(242, 237, 228, 0.23)",
                          opacity: 1,
                          WebkitTextFillColor: "rgba(242, 237, 228, 0.23)",
                          textTransform: "uppercase",
                        },
                      }}
                    />
                  </Box>
                 
                </Box>
      )}
        {isMultipleChoice ? (
          <Box sx={{ width: "min(520px, 92%)", display: "flex", alignItems: "center", gap: 2, mt: 2, mx: "auto" }}>
            <Button
              variant="contained"
              color="primary"
              disabled={isActionLocked}
              onClick={() => submitAnswer()}
              sx={{     position: "relative",
                overflowX: "hidden",
                flex: 1,
                minHeight: 48,
                background: "transparent",
                color: "#F2EDE4",
                border: "none",
                boxShadow: "none",
                padding: "10px 20px",
                fontFamily: "'Cactus Classical Serif', serif",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "23px",
                textAlign: "center",
                textTransform: "uppercase",
                transition: "all 0.3s ease",
                "& .MuiTouchRipple-root": {
                  display: "none",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  borderRadius: "20px",
                  background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                  border: "0.5px solid #1B1B1B",
                  boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
                  pointerEvents: "none",
                  zIndex: 0,
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  inset: "1px",
                  borderRadius: "19px",
                  background: "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                  border: "1px solid rgba(242, 237, 228, 0.08)",
                  pointerEvents: "none",
                  zIndex: 0,
                },
                "&:hover": {
                  backgroundColor: "transparent",
                  "&::after": {
                    border: "1px solid rgba(242, 237, 228, 0.14)",
                  },
                  "&::before": {
                    boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)",
                  },
                },
                "&:active": {
                  backgroundColor: "transparent",
                },
                "&.Mui-focusVisible": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <span style={{ position: "relative", zIndex: 1, display: "inline-block" }}>
                Odeslat odpověď
              </span>
            </Button>
          
          </Box>
        ) : ( 

          <Button
            variant="contained"
            color="primary"
            disabled={isActionLocked}
            onClick={() => submitAnswer()}
            sx={{     position: "relative",
              overflowX: "hidden",
              width: "min(520px, 92%)",
              minHeight: 48,
              background: "transparent",
              color: "#F2EDE4",
              border: "none",
              boxShadow: "none",
              padding: "10px 20px",
              fontFamily: "'Cactus Classical Serif', serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "23px",
              textAlign: "center",
              textTransform: "uppercase",
              transition: "all 0.3s ease",
              mx: "auto",
              "& .MuiTouchRipple-root": {
                display: "none",
              },
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 0,
                borderRadius: "20px",
                background: "linear-gradient(180deg, #F2EDE4 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                border: "0.5px solid #1B1B1B",
                boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
                pointerEvents: "none",
                zIndex: 0,
              },
              "&::after": {
                content: '""',
                position: "absolute",
                inset: "1px",
                borderRadius: "19px",
                background: "linear-gradient(180deg, rgba(242, 237, 228, 0.02) 1.44%, rgba(255, 255, 255, 0) 100%), #1F1F1F",
                border: "1px solid rgba(242, 237, 228, 0.08)",
                pointerEvents: "none",
                zIndex: 0,
              },
              "&:hover": {
                backgroundColor: "transparent",
                "&::after": {
                  border: "1px solid rgba(242, 237, 228, 0.14)",
                },
                "&::before": {
                  boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.1)",
                },
              },
              "&:active": {
                backgroundColor: "transparent",
              },
              "&.Mui-focusVisible": {
                backgroundColor: "transparent",
              },
              mt: 2 }}
          >
            <span style={{ position: "relative", zIndex: 1, display: "inline-block" }}>
              Odeslat odpověď
            </span>
          </Button>
        )}

         {/* ?? Zobrazení nápověd a správné odpovědi */}
         {hintStep > 0 && (
          <Typography variant="body2" sx={{  backgroundColor: "#222",  // Temnější vzhled tlačítka
            color: "#FFFFFF",
            fontFamily: "'Cactus Classical Serif', serif",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "21px",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            padding: "10px 20px",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: "#444",  // Lehce světlejší efekt na hover
                boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)"
            },
            mt: 2 }}>
            {hint1}
          </Typography>
        )}
        {hintStep > 1 && (
          <Typography variant="body2" sx={{  backgroundColor: "#222",  // Temnější vzhled tlačítka
            color: "#FFFFFF",
            fontFamily: "'Cactus Classical Serif', serif",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "21px",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            padding: "10px 20px",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: "#444",  // Lehce světlejší efekt na hover
                boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)"
            },
            mt: 2 }}>
            {hint2}
          </Typography>
        )}
        {hintStep > 2 && (
          <Typography variant="body2" sx={{  backgroundColor: "#222",  // Temnější vzhled tlačítka
            color: "#FFFFFF",
            fontFamily: "'Cactus Classical Serif', serif",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "21px",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            padding: "10px 20px",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: "#444",  // Lehce světlejší efekt na hover
                boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)"
            } ,
            mt: 2}}>
            Správná odpověď: {correctAnswer}
          </Typography>)}

        <Box sx={{ width: "min(520px, 92%)", display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2, pb: 1, mx: "auto", px: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {!!startTime && !isGameCompleted && (
              <Typography
                variant="caption"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontFamily: "'Cactus Classical Serif', serif",
                  fontWeight: 400,
                  fontSize: "21px",
                  lineHeight: "17px",
                  color: "#F2EDE4",
                }}
              >
                <span style={{ fontSize: 27 }}>{ICON_STOPWATCH}</span> {Math.floor(elapsedTime / 60)} min {elapsedTime % 60} s
              </Typography>
            )}
          </Box>
          {/* PRAVÁ STRANA: Čistá ikona nápovědy (stejný styl jako horní odhlášení) */}

          {!hideHintButton && !isStoryScreen && (
  <IconButton
    onClick={useHint}
    disableRipple
    sx={{
      color: "rgba(242, 237, 228, 0.8)",
      padding: 0,
      "&:hover": { color: "#F2EDE4", backgroundColor: "transparent" },
    }}
  >
    <LightbulbOutlinedIcon sx={{ fontSize: 32 }} />
  </IconButton> )}
        
        </Box>
        </Box>
            </Box>
          </Box>
          {renderMapOverlay()}
          {renderImageOverlay()}
        </Box>
      </Paper>
    )}
  </>
)}
  </Box>
</GameLauncher>
)}



    </ContentWrapper>
      </Box>
    </Box>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppInner />
    </ErrorBoundary>
  );
}






















